import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import "./Styles/FormList.css";
import {
    faEdit, faTrash, faSave, faSearch, faRefresh, faSpinner, faCalculator, faFileInvoice, faMoneyBill, faBalanceScale, faBoxes,
    faExclamationTriangle, faCheckCircle, faTimes, faChevronLeft,
    faChevronRight, faFilePdf, faCalendar, faUser, faStore, faPhone,
    faEnvelope, faMapMarkerAlt, faTag, faExchangeAlt, faChevronDown,
    faExpand, faCompress, faArrowsAlt, faMinus, faPlus, faFilter, faEyeSlash,
    faShoppingCart, faEye, faPrint, faDollarSign, faCreditCard, faWallet,
    faReceipt, faHistory, faInfoCircle, faBarcode
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { SaleItemsTable, useBarcodeScanner, buildSaleItem } from './electronics_Sell';
// import './SellList-edit.css';

const SELL_API = 'https://ourzestapp.online/oz_backend/solar_module/solar_sell.php';

// Helper function to adjust color brightness
const adjustColor = (color, amount) => {
    if (!color || !/^#[0-9A-F]{6}$/i.test(color)) return '#6366f1';
    let r = parseInt(color.slice(1, 3), 16);
    let g = parseInt(color.slice(3, 5), 16);
    let b = parseInt(color.slice(5, 7), 16);
    r = Math.max(0, Math.min(255, r + amount));
    g = Math.max(0, Math.min(255, g + amount));
    b = Math.max(0, Math.min(255, b + amount));
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

// Split a business name into a bold first line (first two words) and a
// quieter second line while keeping single/short names graceful.
const splitBusinessName = (name = '') => {
    const words = String(name).trim().split(/\s+/).filter(Boolean);
    const secondaryWords = words.slice(2);
    return {
        primary: words.slice(0, 2).join(' '),
        secondary: secondaryWords.join(' '),
        // Two words are spread word-to-word; one word is spread letter-to-letter.
        secondaryUnits: secondaryWords.length === 1
            ? Array.from(secondaryWords[0])
            : secondaryWords
    };
};

// ============================================
// SHARED TRANSLATOR
// ============================================
const createSalesListTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Sales List': 'سیلز کی فہرست',
                'All sales details are below': 'تمام سیلز کی تفصیلات نیچے ہیں',
                'Bill Number': 'بل نمبر',
                'BN': 'BN',
                'Customer Name': 'کسٹمر کا نام',
                'Phone': 'فون نمبر',
                'Date': 'تاریخ',
                'Grand Total': 'کل رقم',
                'Paid Amount': 'ادا کردہ رقم',
                'Balance': 'باقی رقم',
                'Payment Method': 'ادائیگی کا طریقہ',
                'Payment Status': 'ادائیگی کی حیثیت',
                'Actions': 'اعمال',
                'Added By': 'شامل کرنے والا',
                'Search sales...': 'سیلز تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'View': 'دیکھیں',
                'Print': 'پرنٹ کریں',
                'Close': 'بند کریں',
                'Save Changes': 'تبدیلیاں محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'Switch Shop': 'شاپ تبدیل کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view sales': 'براہ کرم سیلز دیکھنے کے لیے شاپ منتخب کریں',
                'S.No': 'نمبر',
                'Sales': 'سیلز',
                'Shop': 'شاپ',
                'Sale Details': 'سیل کی تفصیلات',
                'Items': 'آئٹمز',
                'Product': 'پروڈکٹ',
                'Quantity': 'مقدار',
                'Price': 'قیمت',
                'Total': 'کل',
                'Subtotal': 'ذیلی کل',
                'Tax': 'ٹیکس',
                'Discount': 'ڈسکاؤنٹ',
                'Update Sale': 'سیل اپ ڈیٹ کریں',
                'Updating...': 'اپ ڈیٹ ہو رہا ہے...',
                'Sale updated successfully': 'سیل کامیابی سے اپ ڈیٹ ہو گئی',
                'Error updating sale': 'سیل اپ ڈیٹ کرنے میں خرابی',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'Yes, Delete': 'ہاں، حذف کریں',
                'No, Cancel': 'نہیں، منسوخ کریں',
                'Portrait': 'عمودی',
                'Landscape': 'افقی',
                'A4': 'A4',
                'Letter': 'لیٹر',
                'Legal': 'لیگل',
                'A5': 'A5',
                'Sales Report': 'سیلز رپورٹ',
                'Sales Directory': 'سیلز ڈائریکٹری',
                'Total Sales': 'کل سیلز',
                'Generated': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Generated by': 'تیار کردہ بذریعہ',
                'Shop Code': 'شاپ کوڈ',
                'FILTERS APPLIED': 'فلٹرز لاگو ہیں',
                'Search': 'تلاش کریں',
                'From': 'سے',
                'To': 'تک',
                'Page': 'صفحہ',
                'Paid': 'ادا شدہ',
                'Unpaid': 'غیر ادا شدہ',
                'Partially Paid': 'جزوی ادا شدہ',
                'All': 'سب',
                'Bill Number Filter': 'بل نمبر',
                'Customer Name Filter': 'کسٹمر کا نام',
                'Phone Filter': 'فون نمبر',
                'Added By Filter': 'شامل کرنے والا',
                'Date Range': 'تاریخ کی حد',
                'Start Date': 'شروع تاریخ',
                'End Date': 'اختتام تاریخ',
                'Payment Status Filter': 'ادائیگی کی حیثیت',
                'Filter By': 'فلٹر کریں بذریعہ',
                'Orientation': 'اورینٹیشن',
                'Page Size': 'صفحہ کا سائز',
                'Cash': 'نقد',
                'Card': 'کارڈ',
                'UPI': 'یوپی آئی',
                'Bank Transfer': 'بینک ٹرانسفر'
            },
            'ar': {
                'Sales List': 'قائمة المبيعات',
                'All sales details are below': 'جميع تفاصيل المبيعات أدناه',
                'Bill Number': 'رقم الفاتورة',
                'BN': 'BN',
                'Customer Name': 'اسم العميل',
                'Phone': 'رقم الهاتف',
                'Date': 'التاريخ',
                'Grand Total': 'المجموع الكلي',
                'Paid Amount': 'المبلغ المدفوع',
                'Balance': 'الرصيد',
                'Payment Method': 'طريقة الدفع',
                'Payment Status': 'حالة الدفع',
                'Actions': 'الإجراءات',
                'Added By': 'أضيف بواسطة',
                'Search sales...': 'بحث عن مبيعات...',
                'Refresh': 'تحديث',
                'Export PDF': 'تصدير PDF',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'View': 'عرض',
                'Print': 'طباعة',
                'Close': 'إغلاق',
                'Save Changes': 'حفظ التغييرات',
                'Cancel': 'إلغاء',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Showing': 'عرض',
                'of': 'من',
                'Previous': 'السابق',
                'Next': 'التالي',
                'Switch Shop': 'تبديل المتجر',
                'No shop selected': 'لم يتم اختيار متجر',
                'Please select a shop to view sales': 'الرجاء اختيار متجر لعرض المبيعات',
                'S.No': 'رقم',
                'Sales': 'مبيعات',
                'Shop': 'متجر',
                'Sale Details': 'تفاصيل البيع',
                'Items': 'العناصر',
                'Product': 'المنتج',
                'Quantity': 'الكمية',
                'Price': 'السعر',
                'Total': 'المجموع',
                'Subtotal': 'المجموع الفرعي',
                'Tax': 'الضريبة',
                'Discount': 'الخصم',
                'Update Sale': 'تحديث البيع',
                'Updating...': 'جاري التحديث...',
                'Sale updated successfully': 'تم تحديث البيع بنجاح',
                'Error updating sale': 'خطأ في تحديث البيع',
                'Confirm Delete': 'تأكيد الحذف',
                'Yes, Delete': 'نعم، حذف',
                'No, Cancel': 'لا، إلغاء',
                'Portrait': 'عمودي',
                'Landscape': 'أفقي',
                'A4': 'A4',
                'Letter': 'رسالة',
                'Legal': 'قانوني',
                'A5': 'A5',
                'Sales Report': 'تقرير المبيعات',
                'Sales Directory': 'دليل المبيعات',
                'Total Sales': 'إجمالي المبيعات',
                'Generated': 'تم الإنشاء',
                'Report ID': 'معرف التقرير',
                'Generated by': 'تم الإنشاء بواسطة',
                'Shop Code': 'رمز المتجر',
                'FILTERS APPLIED': 'المرشحات المطبقة',
                'Search': 'بحث',
                'From': 'من',
                'To': 'إلى',
                'Page': 'صفحة',
                'Paid': 'مدفوع',
                'Unpaid': 'غير مدفوع',
                'Partially Paid': 'مدفوع جزئياً',
                'All': 'الكل',
                'Bill Number Filter': 'رقم الفاتورة',
                'Customer Name Filter': 'اسم العميل',
                'Phone Filter': 'رقم الهاتف',
                'Added By Filter': 'أضيف بواسطة',
                'Date Range': 'نطاق التاريخ',
                'Start Date': 'تاريخ البدء',
                'End Date': 'تاريخ الانتهاء',
                'Payment Status Filter': 'حالة الدفع',
                'Filter By': 'تصفية حسب',
                'Orientation': 'الاتجاه',
                'Page Size': 'حجم الصفحة',
                'Cash': 'نقدي',
                'Card': 'بطاقة',
                'UPI': 'UPI',
                'Bank Transfer': 'تحويل بنكي'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        salesList: 'Sales List',
        formDetails: 'All sales details are below',
        sales: 'Sales',
        shopName: 'Shop',
        noShopSelected: 'No shop selected. Please select a shop first.',
        switchShop: 'Switch Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        searchPlaceholder: 'Search sales...',
        refresh: 'Refresh',
        loadingUserData: 'Loading your sales data...',
        selectShop: 'Please select a shop to view sales',
        billNumber: 'Bill Number',
        bn: 'BN',
        customerName: 'Customer Name',
        phone: 'Phone',
        date: 'Date',
        grandTotal: 'Grand Total',
        paidAmount: 'Paid Amount',
        balance: 'Balance',
        paymentMethod: 'Payment Method',
        paymentStatus: 'Status',
        actions: 'Actions',
        addedBy: 'Added By',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View',
        print: 'Print',
        serialNo: 'S.No',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        billNumberFilter: 'Bill Number',
        customerNameFilter: 'Customer Name',
        phoneFilter: 'Phone Number',
        addedByFilter: 'Added By',
        dateRange: 'Date Range',
        startDate: 'Start Date',
        endDate: 'End Date',
        paymentStatusFilter: 'Payment Status',
        filterBy: 'Filter By',
        exportToPDF: 'Export PDF',
        orientation: 'Orientation',
        portrait: 'Portrait',
        landscape: 'Landscape',
        pageSize: 'Page Size',
        a4: 'A4',
        letter: 'Letter',
        legal: 'Legal',
        a5: 'A5',
        saleDetails: 'Sale Details',
        contactInfo: 'Contact Information',
        addressInfo: 'Address Information',
        editSale: 'Edit Sale',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteMessage: 'Are you sure you want to delete this sale?',
        deleteWarning: 'This action cannot be undone.',
        yesDelete: 'Yes, Delete',
        noCancel: 'No, Cancel',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        close: 'Close',
        salesReport: 'Sales Report',
        salesDirectory: 'Sales Directory',
        totalSales: 'Total Sales',
        generated: 'Generated',
        reportId: 'Report ID',
        generatedBy: 'Generated by',
        shopCode: 'Shop Code',
        filtersApplied: 'FILTERS APPLIED',
        search: 'Search',
        from: 'From',
        to: 'To',
        page: 'Page',
        paid: 'Paid',
        unpaid: 'Unpaid',
        partiallyPaid: 'Partially Paid',
        items: 'Items',
        productName: 'Product',
        quantity: 'Qty',
        price: 'Price',
        total: 'Total',
        subtotal: 'Subtotal',
        tax: 'Tax',
        discount: 'Discount',
        updateSale: 'Update Sale',
        updating: 'Updating...',
        saleUpdated: 'Sale updated successfully',
        updateError: 'Error updating sale',
        cash: 'Cash',
        card: 'Card',
        upi: 'UPI',
        bankTransfer: 'Bank Transfer',
        customerAddress: 'Address',
        notes: 'Notes',
        saleId: 'Sale ID',
        itemBatch: 'Batch',
        itemUnit: 'Unit'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const salesListTranslator = createSalesListTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};


// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading, darkMode }) => {
    if (!isOpen) return null;

    return (
        <div className={`ozlistui-modal-overlay ${darkMode ? 'ozlistui-dark' : ''}`} onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Custom Dropdown Component
const CustomDropdown = ({ label, icon, value, onChange, options, placeholder, translations, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [isHovering, setIsHovering] = useState(false);
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const menuRef = useRef(null);
    const hoverTimeoutRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    // Sync search term with selected value ONLY when not hovering
    useEffect(() => {
        if (!isHovering) {
            setSearchTerm(displayValue);
        }
    }, [displayValue, isHovering]);

    // Close all other dropdowns when this one opens
    useEffect(() => {
        if (isOpen) {
            const event = new CustomEvent('dropdownOpened', { detail: { id: label } });
            window.dispatchEvent(event);
        }
    }, [isOpen, label]);

    // Listen for dropdown opened events from other dropdowns
    useEffect(() => {
        const handleDropdownOpened = (event) => {
            if (event.detail && event.detail.id !== label) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        window.addEventListener('dropdownOpened', handleDropdownOpened);
        return () => window.removeEventListener('dropdownOpened', handleDropdownOpened);
    }, [label]);

    // Filter options - SHOW ALL when hovering, otherwise filter by search term
    const filteredOptions = isHovering
        ? options // Show ALL options when hovering
        : searchTerm.trim() === ''
            ? options
            : options.filter(opt =>
                opt.label.toLowerCase().includes(searchTerm.toLowerCase())
            );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
        setHighlightedIndex(-1);
        setIsHovering(false);
    };

    // Keyboard navigation
    const handleKeyDown = (e) => {
        if (!isOpen) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(true);
                setHighlightedIndex(0);
                setIsHovering(false);
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setHighlightedIndex(prev => 
                    prev < filteredOptions.length - 1 ? prev + 1 : prev
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
                break;
            case 'Enter':
                e.preventDefault();
                if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
                    handleSelect(filteredOptions[highlightedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            case 'Tab':
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            default:
                break;
        }
    };

    // Hover to open - shows ALL options
    const handleMouseEnter = () => {
        if (disabled) return;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        hoverTimeoutRef.current = setTimeout(() => {
            setIsHovering(true);
            setIsOpen(true);
            setHighlightedIndex(0);
        }, 200);
    };

    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        // Don't close immediately - let click outside handle it
        // But reset hovering state after a delay
        setTimeout(() => {
            if (!isOpen) {
                setIsHovering(false);
            }
        }, 300);
    };

    // Click outside to close
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Scroll highlighted item into view
    useEffect(() => {
        if (highlightedIndex >= 0 && menuRef.current) {
            const items = menuRef.current.querySelectorAll('.ozlistui-custom-dropdown-option');
            if (items[highlightedIndex]) {
                items[highlightedIndex].scrollIntoView({ block: 'nearest' });
            }
        }
    }, [highlightedIndex]);

    // Handle input click
    const handleInputClick = () => {
        if (disabled) return;
        setIsHovering(false);
        setSearchTerm(displayValue);
        setIsOpen(true);
        setHighlightedIndex(0);
    };

    // Handle input change (typing)
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setIsHovering(false);
        setSearchTerm(newValue);
        setIsOpen(true);
        setHighlightedIndex(0);
        if (!options.find(opt => opt.label.toLowerCase() === newValue.toLowerCase())) {
            onChange('');
        }
    };

    return (
        <div 
            className="ozlistui-custom-dropdown-wrapper" 
            ref={wrapperRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="ozlistui-custom-input-wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                    onFocus={() => {
                        if (!disabled) {
                            setIsHovering(false);
                            setSearchTerm(displayValue);
                            setIsOpen(true);
                            setHighlightedIndex(0);
                        }
                    }}
                    onKeyDown={handleKeyDown}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozlistui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div className="ozlistui-custom-dropdown-menu" ref={menuRef}>
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((opt, index) => (
                            <div
                                key={opt.value}
                                className={`ozlistui-custom-dropdown-option ${value === opt.value ? 'ozlistui-selected' : ''} ${highlightedIndex === index ? 'ozlistui-highlighted' : ''}`}
                                onClick={() => handleSelect(opt)}
                                onMouseEnter={() => setHighlightedIndex(index)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="ozlistui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// Main Component
const ElectronicsSalesList = () => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [sales, setSales] = useState([]);
    const [filteredSales, setFilteredSales] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedSale, setSelectedSale] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [saleToDelete, setSaleToDelete] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    // PDF Options State
    const [pdfOrientation, setPdfOrientation] = useState('landscape');
    const [pdfPageSize, setPdfPageSize] = useState('a4');
    const [pdfPageRange, setPdfPageRange] = useState('all');
    const [pdfStartPage, setPdfStartPage] = useState(1);
    const [pdfEndPage, setPdfEndPage] = useState(1);

    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 650, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('wide');
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });

    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 650, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 850, label: 'Wide', icon: faPlus },
        full: { width: '95vw', label: 'Full Width', icon: faExpand },
        fullscreen: { width: '98vw', label: 'Full Screen', icon: faCompress }
    };

    // Theme, Dark Mode, Language State
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // Edit form state
    const [editFormData, setEditFormData] = useState({
        id: null,
        date: '',
        bill_number: '',
        bn: '',
        customer_name: '',
        customer_phone: '',
        customer_address: '',
        subtotal: '',
        tax: '',
        discount: '',
        grand_total: '',
        paid_amount: '',
        balance: '',
        payment_method: 'cash',
        payment_status: 'unpaid',
        notes: '',
        courier_name: '',
        tracking_number: '',
        packing_status: 'unpacked',
        items: []
    });
    const [editFormErrors, setEditFormErrors] = useState({});

    // Business info state
    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        bussinesslogo: '',
        businessaddress: '',
        phonenumber: '',
        fullname: '',
        email: '',
        shop_name: '',
        shop_code: ''
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);

    // Filter states
    const [filterBy, setFilterBy] = useState('');
    const [billNumberFilter, setBillNumberFilter] = useState('');
    const [customerNameFilter, setCustomerNameFilter] = useState('');
    const [phoneFilter, setPhoneFilter] = useState('');
    const [addedByFilter, setAddedByFilter] = useState('');
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function (m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    const paymentMethodOptions = useMemo(() => [
        { value: '', label: 'All Methods' },
        { value: 'cash', label: translations.cash || 'Cash' },
        { value: 'card', label: translations.card || 'Card' },
        { value: 'upi', label: translations.upi || 'UPI' },
        { value: 'bank_transfer', label: translations.bankTransfer || 'Bank Transfer' }
    ], [translations]);

    const paymentStatusOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'paid', label: translations.paid || 'Paid' },
        { value: 'unpaid', label: translations.unpaid || 'Unpaid' },
        { value: 'partial', label: translations.partiallyPaid || 'Partially Paid' }
    ], [translations]);

    const filterByOptions = useMemo(() => [
        { value: 'all', label: translations.all || 'All' },
        { value: 'billNumber', label: translations.billNumberFilter || 'Bill Number' },
        { value: 'customerName', label: translations.customerNameFilter || 'Customer Name' },
        { value: 'phone', label: translations.phoneFilter || 'Phone Number' },
        { value: 'added_by', label: translations.addedByFilter || 'Added By' },
        { value: 'date', label: translations.dateRange || 'Date Range' },
        { value: 'paymentStatus', label: translations.paymentStatusFilter || 'Payment Status' }
    ], [translations]);

    const pdfOrientationOptions = useMemo(() => [
        { value: 'portrait', label: translations.portrait || 'Portrait' },
        { value: 'landscape', label: translations.landscape || 'Landscape' }
    ], [translations]);

    const pdfPageSizeOptions = useMemo(() => [
        { value: 'a4', label: translations.a4 || 'A4' },
        { value: 'letter', label: translations.letter || 'Letter' },
        { value: 'legal', label: translations.legal || 'Legal' },
        { value: 'a5', label: translations.a5 || 'A5' }
    ], [translations]);

    // ADD MISSING pdfPageRangeOptions HERE
    const pdfPageRangeOptions = useMemo(() => [
        { value: 'all', label: translations.allPages || 'All Pages' },
        { value: 'range', label: translations.pageRange || 'Page Range' }
    ], [translations]);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100, timeLeft: 3 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    const recalculateEditSale = useCallback((items, taxValue, discountValue, paidValue) => {
        const subtotal = items.reduce((sum, item) => sum + ((Number(item.price) || 0) * (Number(item.quantity) || 0)), 0);
        const tax = Number(taxValue) || 0;
        const discount = Number(discountValue) || 0;
        const paid = Number(paidValue) || 0;
        const grandTotal = Math.max(0, subtotal + tax - discount);
        const balance = grandTotal - paid;
        return { subtotal: subtotal.toFixed(2), grand_total: grandTotal.toFixed(2), balance: balance.toFixed(2),
            payment_status: balance <= 0 ? 'paid' : (paid > 0 ? 'partial' : 'unpaid') };
    }, []);

    const searchEditSaleProducts = useCallback(async (term) => {
        if (!term || term.trim().length < 2 || !user?.username || !currentShop?.shop_id) return [];
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_products.php', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'search_products', searchTerm: term.trim(), username: user.username, shop_id: currentShop.shop_id })
            });
            const result = await response.json();
            return result.status === 'success' ? (result.data || []) : [];
        } catch (error) { return []; }
    }, [user?.username, currentShop?.shop_id]);

    const updateEditSaleItem = useCallback((index, field, value) => {
        setEditFormData(prev => {
            const items = prev.items.map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value,
                total: field === 'price' || field === 'quantity'
                    ? String(Math.round((Number(field === 'price' ? value : item.price) || 0) * (Number(field === 'quantity' ? value : item.quantity) || 0)))
                    : item.total } : item);
            return { ...prev, items, ...recalculateEditSale(items, prev.tax, prev.discount, prev.paid_amount) };
        });
    }, [recalculateEditSale]);

    const selectEditSaleProduct = useCallback((index, product) => {
        setEditFormData(prev => {
            const items = [...prev.items];
            items[index] = { ...items[index], ...buildSaleItem(product, currentShop?.shop_id), quantity: items[index]?.quantity || '1' };
            return { ...prev, items, ...recalculateEditSale(items, prev.tax, prev.discount, prev.paid_amount) };
        });
    }, [currentShop?.shop_id, recalculateEditSale]);

    const addEditSaleItem = useCallback(() => setEditFormData(prev => ({ ...prev, items: [...prev.items, {
        product_id: '', product_name: '', product_code: '', batch_no: '', barcode: '', price: '', quantity: '1',
        available_stock: 0, total: '0.00', sell_method: 'sub_packing', items_per_pack: 1
    }] })), []);

    const removeEditSaleItem = useCallback((index) => setEditFormData(prev => {
        const items = prev.items.filter((_, itemIndex) => itemIndex !== index);
        return { ...prev, items, ...recalculateEditSale(items, prev.tax, prev.discount, prev.paid_amount) };
    }), [recalculateEditSale]);

    const handleEditSaleBarcode = useCallback(async (barcode) => {
        if (!showEditModal) return;
        const matches = await searchEditSaleProducts(barcode);
        const product = matches.find(item => String(item.barcode) === String(barcode)) || matches[0];
        if (!product) return showToast('warning', `Product not found: ${barcode}`);
        setEditFormData(prev => {
            const found = prev.items.findIndex(item => String(item.product_id) === String(product.id));
            let items;
            if (found >= 0) items = prev.items.map((item, index) => index === found ? { ...item, quantity: String((Number(item.quantity) || 0) + 1) } : item);
            else items = [...prev.items, buildSaleItem(product, currentShop?.shop_id)];
            return { ...prev, items, ...recalculateEditSale(items, prev.tax, prev.discount, prev.paid_amount) };
        });
    }, [showEditModal, searchEditSaleProducts, currentShop?.shop_id, recalculateEditSale, showToast]);

    useBarcodeScanner(handleEditSaleBarcode, showEditModal && !editLoading);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ============================================
    // THEME SYNC
    // ============================================
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }
        document.documentElement.style.setProperty('--ozlistui-primary', color);
        document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
        document.documentElement.style.setProperty('--ozlistui-primary-light', color);
        setCurrentTheme(color);

        // Update dynamic styles
        let style = document.getElementById('dynamic-list-styles');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-list-styles';
            document.head.appendChild(style);
        }

        style.textContent = `
            .ozlistui-table thead th {
                color: ${color};
                border-bottom-color: ${color};
            }
            .ozlistui-payment-badge {
                border-color: ${color}40;
            }
            .ozlistui-page-number.ozlistui-active {
                background: ${color};
                border-color: ${color};
            }
            .ozlistui-action-btn.ozlistui-edit-btn:hover:not(:disabled) {
                background: ${color};
            }
            .ozlistui-header-shop-btn,
            .ozlistui-header-filter-btn {
                background: linear-gradient(135deg, ${color}, ${adjustColor(color, -20)});
            }
            .ozlistui-btn-primary {
                background: ${color};
            }
            .ozlistui-custom-dropdown-option.ozlistui-selected {
                background: ${color};
            }
        `;
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentTheme) {
                applyTheme(storedTheme);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [applyTheme, currentTheme]);

    // ============================================
    // DARK MODE SYNC
    // ============================================
    const syncDarkMode = useCallback(() => {
        const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
        setDarkMode(isDark);

        const container = document.querySelector('.ozlistui-container');
        if (container) {
            if (isDark) {
                container.classList.add('ozlistui-dark');
            } else {
                container.classList.remove('ozlistui-dark');
            }
        }

        // Also update modal overlays
        const overlays = document.querySelectorAll('.ozlistui-modal-overlay');
        overlays.forEach(overlay => {
            if (isDark) {
                overlay.classList.add('ozlistui-dark');
            } else {
                overlay.classList.remove('ozlistui-dark');
            }
        });

        if (isDark) {
            document.body.classList.add('ozlistui-dark');
            document.documentElement.classList.add('ozlistui-dark');
        } else {
            document.body.classList.remove('ozlistui-dark');
            document.documentElement.classList.remove('ozlistui-dark');
        }
    }, []);

    useEffect(() => {
        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozlistui-dark');
                    } else {
                        container.classList.remove('ozlistui-dark');
                    }
                }
                const overlays = document.querySelectorAll('.ozlistui-modal-overlay');
                overlays.forEach(overlay => {
                    if (isDark) {
                        overlay.classList.add('ozlistui-dark');
                    } else {
                        overlay.classList.remove('ozlistui-dark');
                    }
                });
                if (isDark) {
                    document.body.classList.add('ozlistui-dark');
                    document.documentElement.classList.add('ozlistui-dark');
                } else {
                    document.body.classList.remove('ozlistui-dark');
                    document.documentElement.classList.remove('ozlistui-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [syncDarkMode, darkMode]);

    // ============================================
    // LANGUAGE SYNC
    // ============================================
    const loadTranslations = useCallback(async (lang) => {
        const trans = await salesListTranslator.getTranslations(lang);
        setTranslations(trans);
    }, []);

    useEffect(() => {
        loadTranslations(currentLanguage);

        const handleStorageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage, loadTranslations]);

    // ============================================
    // RTL DIRECTION SYNC
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozlistui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // Center modal function
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        if (mode === 'fullscreen') {
            modalRef.current.style.width = '98vw';
            modalRef.current.style.height = '90vh';
        } else {
            modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
            modalRef.current.style.height = 'auto';
        }
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .ozlistui-width-btn, .ozlistui-close-btn')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    useEffect(() => {
        if (showEditModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('wide'); setIsModalInitialized(true); }, 50);
        }
        if (!showEditModal) setIsModalInitialized(false);
    }, [showEditModal, centerModal, setWidthMode, isModalInitialized]);

    useEffect(() => {
        const handleWindowResize = () => {
            if (!modalRef.current || !showEditModal) return;
            const rect = modalRef.current.getBoundingClientRect();
            let newLeft = Math.min(rect.left, window.innerWidth - rect.width);
            let newTop = Math.min(rect.top, window.innerHeight - rect.height);
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, newTop);
            if (newLeft !== rect.left || newTop !== rect.top) {
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalPosition({ x: newLeft, y: newTop });
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [showEditModal]);

    // Fetch sales
    const fetchSales = useCallback(async () => {
        if (!user || !user.username) {
            if (isMountedRef.current) {
                showToast('error', 'User information not available');
                setLoading(false);
            }
            return;
        }
        if (!currentShop) {
            if (isMountedRef.current) {
                showToast('error', translations.noShopSelected || 'Please select a shop first');
                setLoading(false);
            }
            return;
        }
        if (isMountedRef.current) setLoading(true);
        try {
            const response = await fetch(SELL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_records',
                    username: user.username,
                    shop_id: currentShop.shop_id,
                    filters: {}
                })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setSales(data.data || []);
                    setFilteredSales(data.data || []);
                    resetFilters();
                } else {
                    showToast('error', data.message || translations.networkError || 'Network error occurred');
                }
            }
        } catch (error) {
            console.error('Error fetching sales:', error);
            if (isMountedRef.current) showToast('error', translations.networkError || 'Network error occurred');
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [user, currentShop, translations, showToast]);

    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php?action=get_business_info&username=' + encodeURIComponent(user.username), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'include'
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setBusinessInfo({
                        businessname: data.businessname || '',
                        bussinesslogo: data.bussinesslogo || '',
                        bussinesslogo_url: data.bussinesslogo_url || '',
                        businessaddress: data.businessaddress || '',
                        phonenumber: data.phonenumber || '',
                        email: data.email || '',
                        fullname: data.fullname || '',
                        shop_name: data.shop_name || '',
                        shop_code: data.shop_code || '',
                        shop_id: data.shop_id || '',
                        default_shop_id: data.default_shop_id || '',
                        role: data.role || '',
                        all_shops: data.all_shops || []
                    });
                } else {
                    // Fallback to user data
                    setBusinessInfo({
                        businessname: user.business_name || user.fullname || '',
                        bussinesslogo: '',
                        bussinesslogo_url: '',
                        businessaddress: user.business_address || '',
                        phonenumber: user.phonenumber || '',
                        email: user.email || '',
                        fullname: user.fullname || '',
                        shop_name: currentShop?.shop_name || '',
                        shop_code: currentShop?.shop_code || '',
                        shop_id: currentShop?.shop_id || '',
                        default_shop_id: currentShop?.shop_id || '',
                        role: user.role || '',
                        all_shops: []
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            if (isMountedRef.current) {
                setBusinessInfo({
                    businessname: user.business_name || user.fullname || '',
                    bussinesslogo: '',
                    bussinesslogo_url: '',
                    businessaddress: user.business_address || '',
                    phonenumber: user.phonenumber || '',
                    email: user.email || '',
                    fullname: user.fullname || '',
                    shop_name: currentShop?.shop_name || '',
                    shop_code: currentShop?.shop_code || '',
                    shop_id: currentShop?.shop_id || '',
                    default_shop_id: currentShop?.shop_id || '',
                    role: user.role || '',
                    all_shops: []
                });
            }
        }
    }, [user, currentShop]);

    useEffect(() => {
        if (user && user.username && currentShop) {
            fetchSales();

            fetchBusinessInfo();
            fetchAvailableShops();
        } else if (user && user.username && !currentShop) {
            setLoading(false);
        } else if (!user) {
            setLoading(false);
        }
    }, [user, currentShop?.shop_id]);

    const handleSwitchShop = useCallback(async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', 'Shop switched successfully');
                setCurrentPage(1);
                resetFilters();
                setShowShopSelector(false);
            } else {
                showToast('error', 'Failed to switch shop');
            }
        } catch (error) {
            console.error('Error switching shop:', error);
            showToast('error', 'Failed to switch shop');
        }
    }, [switchShop, showToast]);

    const applyFilters = useCallback(() => {
        let filtered = [...sales];
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(sale =>
                sale.bill_number?.toLowerCase().includes(term) ||
                sale.bn?.toLowerCase().includes(term) ||
                sale.customer_name?.toLowerCase().includes(term) ||
                sale.customer_phone?.toLowerCase().includes(term) ||
                sale.username?.toLowerCase().includes(term)
            );
        }
        if (filterBy === 'billNumber' && billNumberFilter.trim()) {
            const term = billNumberFilter.toLowerCase();
            filtered = filtered.filter(sale => sale.bill_number?.toLowerCase().includes(term));
        }
        if (filterBy === 'customerName' && customerNameFilter.trim()) {
            const term = customerNameFilter.toLowerCase();
            filtered = filtered.filter(sale => sale.customer_name?.toLowerCase().includes(term));
        }
        if (filterBy === 'phone' && phoneFilter.trim()) {
            const term = phoneFilter.toLowerCase();
            filtered = filtered.filter(sale => sale.customer_phone?.toLowerCase().includes(term));
        }
        if (filterBy === 'added_by' && addedByFilter.trim()) {
            const term = addedByFilter.toLowerCase();
            filtered = filtered.filter(sale => sale.username?.toLowerCase().includes(term));
        }
        if (filterBy === 'paymentStatus' && paymentStatusFilter) {
            if (paymentStatusFilter === 'paid') {
                filtered = filtered.filter(sale => {
                    const balance = parseFloat(sale.balance) || 0;
                    return balance <= 0;
                });
            } else if (paymentStatusFilter === 'unpaid') {
                filtered = filtered.filter(sale => {
                    const paid = parseFloat(sale.paid_amount) || 0;
                    return paid === 0;
                });
            } else if (paymentStatusFilter === 'partial') {
                filtered = filtered.filter(sale => {
                    const paid = parseFloat(sale.paid_amount) || 0;
                    const balance = parseFloat(sale.balance) || 0;
                    return paid > 0 && balance > 0;
                });
            }
        }
        if (startDate) {
            const start = new Date(startDate);
            start.setHours(0, 0, 0, 0);
            filtered = filtered.filter(sale => {
                if (!sale.date) return false;
                const saleDate = new Date(sale.date);
                saleDate.setHours(0, 0, 0, 0);
                return saleDate >= start;
            });
        }
        if (endDate) {
            const end = new Date(endDate);
            end.setHours(23, 59, 59, 999);
            filtered = filtered.filter(sale => {
                if (!sale.date) return false;
                const saleDate = new Date(sale.date);
                return saleDate <= end;
            });
        }
        setFilteredSales(filtered);
        setCurrentPage(1);
    }, [sales, searchTerm, filterBy, billNumberFilter, customerNameFilter, phoneFilter, addedByFilter, paymentStatusFilter, startDate, endDate]);

    useEffect(() => { applyFilters(); }, [applyFilters]);

    const resetFilters = useCallback(() => {
        setFilterBy('');
        setBillNumberFilter('');
        setCustomerNameFilter('');
        setPhoneFilter('');
        setAddedByFilter('');
        setPaymentStatusFilter('');
        setStartDate('');
        setEndDate('');
        setSearchTerm('');
    }, []);

    const formatDate = useCallback((dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        } catch { return dateString; }
    }, []);

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return 'Rs. 0';
        return `Rs. ${Math.round(parseFloat(amount) || 0)}`;
    };

    const getPaymentStatus = (paid, grandTotal) => {
        const paidAmount = parseFloat(paid) || 0;
        const totalAmount = parseFloat(grandTotal) || 0;
        const balance = totalAmount - paidAmount;

        if (balance <= 0) {
            return { status: 'paid', text: translations.paid || 'Paid', color: '#10b981' };
        } else if (paidAmount === 0) {
            return { status: 'unpaid', text: translations.unpaid || 'Unpaid', color: '#ef4444' };
        } else {
            return { status: 'partial', text: translations.partiallyPaid || 'Partial', color: '#f59e0b' };
        }
    };

    const getPaymentMethodLabel = (method) => {
        const map = {
            'cash': translations.cash || 'Cash',
            'card': translations.card || 'Card',
            'upi': translations.upi || 'UPI',
            'bank_transfer': translations.bankTransfer || 'Bank Transfer'
        };
        return map[method] || method || '-';
    };

    const getTodayDate = useCallback(() => new Date().toISOString().split('T')[0], []);

    // Get rows per page - Landscape: 20 rows, Portrait: 15 rows
    const getRowsPerPage = useCallback(() => {
        if (pdfOrientation === 'landscape') {
            return 20;
        }
        return 15;
    }, [pdfOrientation]);

    const pagination = useMemo(() => {
        const totalPages = Math.ceil(filteredSales.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentSales = filteredSales.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentSales };
    }, [filteredSales, currentPage, itemsPerPage]);

    // PDF EXPORT FUNCTION
    const exportToPDF = useCallback(async () => {
        if (!filteredSales || filteredSales.length === 0) {
            showToast('warning', translations.noDataToExport || 'No data to export');
            return;
        }
        setPdfLoading(true);
        try {
            const currentLang = currentLanguage;
            const isRTL = currentLang === 'ur' || currentLang === 'ar';

            const pdfTextColor = '#1f2937';
            const pdfSubTextColor = '#6b7280';
            const pdfBorderColor = '#e5e7eb';
            const pdfHeaderBgColor = '#f9fafb';
            const pdfRowEvenBg = '#ffffff';
            const pdfRowOddBg = '#f9fafb';
            const pdfThemeColor = currentTheme;

            const pageSizeMap = { 'a4': 'a4', 'letter': 'letter', 'legal': 'legal', 'a5': 'a5' };
            const pageFormat = pageSizeMap[pdfPageSize] || 'a4';
            const pdf = new jsPDF({ orientation: pdfOrientation, unit: 'mm', format: pageFormat, compress: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const rowsPerPage = getRowsPerPage();

            let salesToExport = [...filteredSales];

            if (pdfPageRange === 'range') {
                const totalPagesForRange = Math.ceil(salesToExport.length / rowsPerPage);
                const start = Math.max(1, pdfStartPage);
                const end = Math.min(totalPagesForRange, pdfEndPage);
                const startIdx = (start - 1) * rowsPerPage;
                const endIdx = Math.min(end * rowsPerPage, salesToExport.length);
                salesToExport = salesToExport.slice(startIdx, endIdx);
            }

            const totalPages = Math.ceil(salesToExport.length / rowsPerPage);

            const getPDFTranslation = (key, fallback = '') => {
                return translations[key] || fallback;
            };

            const formatCurrencyForPDF = (amount) => {
                if (!amount && amount !== 0) return 'Rs. 0';
                return `Rs. ${Math.round(parseFloat(amount) || 0)}`;
            };

            const formatDateForPDF = (dateString) => {
                if (!dateString) return '-';
                try {
                    const date = new Date(dateString);
                    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                } catch { return dateString; }
            };

            const renderPage = async (pageSales, pageNum, startRowIndex) => {
                return new Promise((resolve, reject) => {
                    try {
                        const container = document.createElement('div');
                        container.style.width = '750px';
                        container.style.padding = '12px 15px';
                        container.style.backgroundColor = '#ffffff';
                        container.style.color = pdfTextColor;
                        container.style.position = 'absolute';
                        container.style.left = '-9999px';
                        container.style.top = '0';
                        container.style.fontFamily = "'Segoe UI', 'Helvetica Neue', Arial, sans-serif";
                        container.style.direction = isRTL ? 'rtl' : 'ltr';

                        const salesReportLabel = getPDFTranslation('salesReport', 'Sales Report');
                        const salesDirectoryLabel = getPDFTranslation('salesDirectory', 'Sales Directory');
                        const totalSalesLabel = getPDFTranslation('totalSales', 'Total Sales');
                        const generatedLabel = getPDFTranslation('generated', 'Generated');
                        const reportIdLabel = getPDFTranslation('reportId', 'Report ID');
                        const generatedByLabel = getPDFTranslation('generatedBy', 'Generated by');
                        const shopCodeLabel = getPDFTranslation('shopCode', 'Shop Code');
                        const filtersAppliedLabel = getPDFTranslation('filtersApplied', 'FILTERS APPLIED');
                        const searchLabel = getPDFTranslation('search', 'Search');
                        const fromLabel = getPDFTranslation('from', 'From');
                        const toLabel = getPDFTranslation('to', 'To');
                        const pageLabel = getPDFTranslation('page', 'Page');
                        const ofLabel = getPDFTranslation('of', 'of');
                        const billNumberLabel = getPDFTranslation('billNumber', 'Bill No');
                        const bnLabel = getPDFTranslation('bn', 'BN');
                        const customerNameLabel = getPDFTranslation('customerName', 'Customer');
                        const phoneLabel = getPDFTranslation('phone', 'Phone');
                        const dateLabel = getPDFTranslation('date', 'Date');
                        const grandTotalLabel = getPDFTranslation('grandTotal', 'Total');
                        const paidAmountLabel = getPDFTranslation('paidAmount', 'Paid');
                        const balanceLabel = getPDFTranslation('balance', 'Balance');
                        const paymentStatusLabel = getPDFTranslation('paymentStatus', 'Status');
                        const addedByLabel = getPDFTranslation('addedBy', 'Added By');

                        const totalGrandTotal = pageSales.reduce((sum, sale) => sum + (parseFloat(sale.grand_total) || 0), 0);
                        const totalPaid = pageSales.reduce((sum, sale) => sum + (parseFloat(sale.paid_amount) || 0), 0);
                        const totalBalance = pageSales.reduce((sum, sale) => sum + (parseFloat(sale.balance) || 0), 0);

                        const headerHTML = `
                            <div style="margin-bottom: 12px; text-align: center;">
                                <div style="font-size: 8px; letter-spacing: 3px; color: ${pdfSubTextColor}; margin-bottom: 4px; text-transform: uppercase; font-weight: 500;">${salesReportLabel}</div>
                                <h1 style="color: ${pdfTextColor}; font-size: 20px; margin: 0 0 4px 0; font-weight: 600;">
                                    ${escapeHtml(currentShop?.shop_name) || escapeHtml(salesDirectoryLabel)}
                                </h1>
                                <div style="width: 40px; height: 2px; background: ${pdfThemeColor}; margin: 6px auto;"></div>
                                ${businessInfo.businessname ? `<div style="color: ${pdfSubTextColor}; font-size: 10px; margin-top: 4px;">${escapeHtml(businessInfo.businessname)}</div>` : ''}
                                <div style="color: ${pdfSubTextColor}; font-size: 7px; margin-top: 4px;">
                                    ${totalSalesLabel}: ${salesToExport.length} | ${generatedLabel}: ${new Date().toLocaleString(currentLang)}
                                </div>
                            </div>
                            <div style="display: flex; justify-content: space-between; margin: 8px 0 10px 0; padding: 5px 0; border-top: 1px solid ${pdfBorderColor}; border-bottom: 1px solid ${pdfBorderColor}; ${isRTL ? 'flex-direction: row-reverse;' : ''}">
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};"><strong>${reportIdLabel}:</strong> #${new Date().toISOString().slice(0, 10).replace(/-/g, '')}-${String(pageNum).padStart(3, '0')}</div>
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};"><strong>${generatedByLabel}:</strong> ${escapeHtml(user?.fullname || user?.username || 'System')}</div>
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};"><strong>${shopCodeLabel}:</strong> ${escapeHtml(currentShop?.shop_code || 'N/A')}</div>
                            </div>
                        `;

                        const hasFilters = searchTerm || paymentStatusFilter || startDate || endDate;
                        const filterHTML = hasFilters ? `
                            <div style="margin: 6px 0; padding: 4px 10px; background: #f7f7f7; border-${isRTL ? 'right' : 'left'}: 3px solid ${pdfThemeColor}; font-size: 6.5px; color: ${pdfSubTextColor};">
                                <span style="font-weight: 600;">${filtersAppliedLabel}:</span> 
                                ${searchTerm ? `${searchLabel}: "${escapeHtml(searchTerm)}"` : ''}
                                ${paymentStatusFilter ? ` | ${getPDFTranslation('paymentStatus', 'Status')}: ${paymentStatusFilter === 'paid' ? getPDFTranslation('paid', 'Paid') : paymentStatusFilter === 'unpaid' ? getPDFTranslation('unpaid', 'Unpaid') : getPDFTranslation('partiallyPaid', 'Partial')}` : ''}
                                ${startDate ? ` | ${fromLabel}: ${startDate}` : ''}
                                ${endDate ? ` | ${toLabel}: ${endDate}` : ''}
                            </div>
                        ` : '';

                        let tableHTML = `
                            <table style="width: 100%; border-collapse: collapse; font-size: 6.5px; margin-top: 4px;">
                                <thead>
                                    <tr style="background-color: ${pdfHeaderBgColor}; border-bottom: 2px solid ${pdfThemeColor};">
                                        <th style="padding: 4px 3px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%;">#</th>
                                        <th style="padding: 4px 3px; text-align: ${isRTL ? 'right' : 'left'}; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 10%;">${dateLabel}</th>
                                        <th style="padding: 4px 3px; text-align: ${isRTL ? 'right' : 'left'}; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 8%;">${bnLabel}</th>
                                        <th style="padding: 4px 3px; text-align: ${isRTL ? 'right' : 'left'}; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 14%;">${customerNameLabel}</th>
                                        <th style="padding: 4px 3px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 10%;">${phoneLabel}</th>
                                        <th style="padding: 4px 3px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 10%;">${grandTotalLabel}</th>
                                        <th style="padding: 4px 3px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 10%;">${paidAmountLabel}</th>
                                        <th style="padding: 4px 3px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 10%;">${balanceLabel}</th>
                                        <th style="padding: 4px 3px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 8%;">${paymentStatusLabel}</th>
                                        <th style="padding: 4px 3px; text-align: center; font-weight: 700; color: ${pdfTextColor}; width: 6%;">${addedByLabel}</th>
                                    </tr>
                                </thead>
                                <tbody>
                        `;

                        pageSales.forEach((sale, idx) => {
                            const rowNum = startRowIndex + idx + 1;
                            const isEven = idx % 2 === 0;
                            const paymentStatus = getPaymentStatus(sale.paid_amount, sale.grand_total);

                            tableHTML += `
                                <tr style="border-bottom: 0.5px solid ${pdfBorderColor}; background: ${isEven ? pdfRowEvenBg : pdfRowOddBg};">
                                    <td style="padding: 3px; text-align: center; color: ${pdfSubTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${rowNum}</td>
                                    <td style="padding: 3px; text-align: ${isRTL ? 'right' : 'left'}; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${formatDateForPDF(sale.date)}</td>
                                    <td style="padding: 3px; text-align: ${isRTL ? 'right' : 'left'}; color: ${pdfTextColor}; font-weight: 500; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace;">${escapeHtml(sale.bill_number) || '-'}</td>
                                    <td style="padding: 3px; text-align: ${isRTL ? 'right' : 'left'}; color: ${pdfTextColor}; font-weight: 500; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace;">${escapeHtml(sale.bn) || '-'}</td>
                                    <td style="padding: 3px; text-align: ${isRTL ? 'right' : 'left'}; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor};">${escapeHtml(sale.customer_name) || (translations.walkInCustomer || 'Walk-in')}</td>
                                    <td style="padding: 3px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace;">${escapeHtml(sale.customer_phone) || '—'}</td>
                                    <td style="padding: 3px; text-align: right; color: #059669; font-weight: 600; border-right: 0.5px solid ${pdfBorderColor};">${formatCurrencyForPDF(sale.grand_total)}</td>
                                    <td style="padding: 3px; text-align: right; color: #3b82f6; font-weight: 600; border-right: 0.5px solid ${pdfBorderColor};">${formatCurrencyForPDF(sale.paid_amount)}</td>
                                    <td style="padding: 3px; text-align: right; color: ${parseFloat(sale.balance) > 0 ? '#d97706' : '#059669'}; font-weight: 600; border-right: 0.5px solid ${pdfBorderColor};">${formatCurrencyForPDF(sale.balance)}</td>
                                    <td style="padding: 3px; text-align: center; color: ${paymentStatus.color}; font-weight: 600; border-right: 0.5px solid ${pdfBorderColor};">${paymentStatus.text}</td>
                                    <td style="padding: 3px; text-align: center; color: ${pdfTextColor};">${escapeHtml(sale.username) || '—'}</td>
                                </tr>
                            `;
                        });

                        const emptyRowsNeeded = rowsPerPage - pageSales.length;
                        for (let i = 0; i < emptyRowsNeeded; i++) {
                            tableHTML += `
                                <tr style="border-bottom: 0.5px solid ${pdfBorderColor}; background: ${(pageSales.length + i) % 2 === 0 ? pdfRowEvenBg : pdfRowOddBg};">
                                    <td style="padding: 3px; text-align: center; color: ${pdfSubTextColor}; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px;">&nbsp;</td>
                                </tr>
                            `;
                        }

                        tableHTML += `
                                    <tr style="border-top: 1px solid ${pdfBorderColor}; background-color: #f8f8f8;">
                                        <td colspan="6" style="padding: 4px 3px; text-align: ${isRTL ? 'right' : 'left'}; font-weight: 700;">Page Summary</td>
                                        <td style="padding: 4px 3px; text-align: right; font-weight: 700; color: #059669;">${formatCurrencyForPDF(totalGrandTotal)}</td>
                                        <td style="padding: 4px 3px; text-align: right; font-weight: 700; color: #3b82f6;">${formatCurrencyForPDF(totalPaid)}</td>
                                        <td style="padding: 4px 3px; text-align: right; font-weight: 700; color: #d97706;">${formatCurrencyForPDF(totalBalance)}</td>
                                        <td colspan="2">&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        `;

                        const footerHTML = `
                            <div style="margin-top: 8px; padding-top: 5px; text-align: center;">
                                <div style="width: 30px; height: 1px; background: ${pdfBorderColor}; margin: 0 auto 5px auto;"></div>
                                <div style="font-size: 6.5px; color: ${pdfSubTextColor};">${pageLabel} ${pageNum} ${ofLabel} ${totalPages}</div>
                                <div style="font-size: 5px; color: #aaa; margin-top: 3px;">${translations.poweredBy || 'Powered by OurZest'}</div>
                            </div>
                        `;

                        container.innerHTML = headerHTML + filterHTML + tableHTML + footerHTML;
                        document.body.appendChild(container);
                        html2canvas(container, { scale: 2, backgroundColor: '#ffffff', logging: false }).then(canvas => {
                            document.body.removeChild(container);
                            resolve(canvas);
                        }).catch(err => { document.body.removeChild(container); reject(err); });
                    } catch (err) { reject(err); }
                });
            };

            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                const startRow = (pageNum - 1) * rowsPerPage;
                const endRow = Math.min(pageNum * rowsPerPage, salesToExport.length);
                const pageSales = salesToExport.slice(startRow, endRow);
                const canvas = await renderPage(pageSales, pageNum, startRow);
                if (pageNum > 1) {
                    pdf.addPage();
                }
                const imgWidth = pageWidth - 20;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 5, imgWidth, imgHeight);
            }

            const fileName = `Sales_Report_${currentShop?.shop_name?.replace(/[^a-z0-9]/gi, '_') || 'Export'}_${new Date().toISOString().slice(0, 10)}.pdf`;
            pdf.save(fileName);
            showToast('success', `${translations.reportGenerated || 'Report generated!'} ${salesToExport.length} ${translations.sales || 'sales'} on ${totalPages} ${translations.pages || 'page(s)'}`);
        } catch (error) {
            console.error('PDF Error:', error);
            showToast('error', translations.pdfGenerationError || 'Error generating PDF');
        } finally {
            setPdfLoading(false);
        }
    }, [filteredSales, currentLanguage, pdfOrientation, pdfPageSize, pdfPageRange, pdfStartPage, pdfEndPage, translations, businessInfo, currentShop, user, showToast, getRowsPerPage, searchTerm, paymentStatusFilter, startDate, endDate, currentTheme]);



    const loadBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/get_business_info.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_business_info', username: user.username })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setBusinessInfo({
                        businessname: data.businessname || '',
                        bussinesslogo: data.bussinesslogo || '',
                        businessaddress: data.businessaddress || '',
                        phonenumber: data.phonenumber || '',
                        email: data.email || '',
                        fullname: data.fullname || '',
                        shop_name: data.shop_name || '',
                        shop_code: data.shop_code || ''
                    });
                } else {
                    setBusinessInfo({
                        businessname: user.business_name || user.fullname || '',
                        bussinesslogo: '',
                        businessaddress: '',
                        phonenumber: user.phonenumber || '',
                        email: user.email || '',
                        fullname: user.fullname || '',
                        shop_name: currentShop?.shop_name || '',
                        shop_code: currentShop?.shop_code || ''
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            if (isMountedRef.current) {
                setBusinessInfo({
                    businessname: user.business_name || user.fullname || '',
                    bussinesslogo: '',
                    businessaddress: '',
                    phonenumber: user.phonenumber || '',
                    email: user.email || '',
                    fullname: user.fullname || '',
                    shop_name: currentShop?.shop_name || '',
                    shop_code: currentShop?.shop_code || ''
                });
            }
        }
    }, [user, currentShop]);

    // ============================================
    // PRINT RECEIPT FUNCTION - Updated with centered header, bill number on its own line, and date + time
    // ============================================
  // ============================================
// PRINT BILL - A4/A5/LETTER/LEGAL FORMAT
// ============================================
// ============================================
// PRINT BILL - COMPLETE FIXED VERSION
// ============================================
// ============================================
// PRINT BILL - COMPLETE FIXED VERSION (NO WARRANTY QR)
// ============================================
const handlePrint = async (sale) => {
    if (!sale) return;
    showToast('info', 'Preparing sales receipt...');

    let saleData = sale;
    if (!sale.items && sale.id && currentShop) {
        try {
            const response = await fetch(SELL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    action: 'get_record', 
                    id: sale.id, 
                    shop_id: currentShop.shop_id 
                })
            });
            const result = await response.json();
            if (result.status !== 'success' || !result.data) throw new Error('Sale details not found');
            saleData = result.data;
        } catch (error) {
            console.error('Error fetching sale details for print:', error);
            showToast('error', 'Could not load sale details for printing');
            return;
        }
    }

    if (!saleData.items?.length) {
        showToast('warning', 'No items to print');
        return;
    }

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        showToast('error', 'Please allow popups for printing');
        return;
    }

    const businessName = businessInfo?.businessname || user?.business_name || user?.fullname || currentShop?.shop_name || 'OurZest Store';
    const businessLogo = businessInfo?.bussinesslogo_url || businessInfo?.bussinesslogo || '';
    const businessAddress = businessInfo?.businessaddress || user?.business_address || '';
    const businessPhone = businessInfo?.phonenumber || user?.phonenumber || '';
    const businessEmail = businessInfo?.email || user?.email || '';
    const salesBusinessName = splitBusinessName(businessName);
    const customerName = saleData.customer_name || saleData.customer || 'Walk-in Customer';
    const customerPhone = saleData.customer_phone || saleData.phone || '';
    const bn = saleData.bn || saleData.bill_number || saleData.id || '';
    const pageSizes = { a4: 'A4', a5: 'A5', letter: 'Letter', legal: 'Legal' };
    const printPageSize = pageSizes[String(pdfPageSize || 'a4').toLowerCase()] || 'A4';
    const money = value => `Rs. ${Math.round(Number.parseFloat(value) || 0)}`;
    const itemsSubtotal = saleData.items.reduce((sum, item) => {
        const lineTotal = Number.parseFloat(item.total);
        return sum + (Number.isFinite(lineTotal) ? lineTotal : (Number(item.price) || 0) * (Number(item.quantity) || 0));
    }, 0);
    const subtotal = saleData.subtotal ?? itemsSubtotal;
    const tax = saleData.tax || 0;
    const discount = saleData.discount || 0;
    const grandTotal = saleData.grand_total ?? (Number(subtotal) + Number(tax) - Number(discount));
    const paidAmount = saleData.paid_amount ?? saleData.paid ?? grandTotal;
    const balance = saleData.balance ?? (Number(grandTotal) - Number(paidAmount));
    const previousBalance = Number(saleData.previous_balance || 0);
    const payableTotal = Number(saleData.payable_total ?? (Number(grandTotal) + previousBalance));
    const paymentLines = (() => {
        if (Array.isArray(saleData.payments)) return saleData.payments;
        if (Array.isArray(saleData.payment_breakdown)) return saleData.payment_breakdown;
        if (typeof saleData.payment_breakdown !== 'string' || !saleData.payment_breakdown.trim()) return [];
        try {
            const parsed = JSON.parse(saleData.payment_breakdown);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    })();
    const paymentTypeLabel = type => ({
        cash: 'Cash',
        digital_wallet: 'Digital Wallet',
        bank_account: 'Bank Account'
    }[type] || String(type || 'Payment'));
    const receiptDate = (() => {
        const date = saleData.date ? new Date(saleData.date) : new Date();
        const safeDate = Number.isNaN(date.getTime()) ? new Date() : date;
        return safeDate.toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    })();

    printWindow.document.write(`<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>Sales Receipt ${escapeHtml(String(bn))}</title>
<style>
@page { size: ${printPageSize} portrait; margin: 12mm; }
* { box-sizing: border-box; }
:root { --ink: #000; --muted: #444; --line: #b8b8b8; --soft: #fafafa; --header-mark-size: 112px; }
body { margin: 0; color: var(--ink); background: #fff; font: 10pt/1.45 'Segoe UI', Arial, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.receipt { width: 100%; margin: 0 auto; }
.header { margin-bottom: 0; text-align: left; }
.brand { display: flex; align-items: center; justify-content: flex-start; gap: 18px; min-height: 140px; padding: 14px 4px 22px; }
.logo { display: block; flex: 0 0 var(--header-mark-size); width: var(--header-mark-size); height: var(--header-mark-size); max-width: var(--header-mark-size); max-height: var(--header-mark-size); object-fit: contain; filter: grayscale(100%) contrast(115%); }
.business-copy { min-width: 0; text-align: left; flex: 1; }
.business-name-lockup { display: inline-flex; flex-direction: column; width: max-content; max-width: 100%; }
.business-name-primary { font-size: 28pt; font-weight: 850; letter-spacing: .25px; line-height: 1.02; overflow-wrap: anywhere; }
.business-name-secondary { display: flex; justify-content: flex-start; width: 100%; margin-top: 4px; font-size: 17pt; font-weight: 650; line-height: 1.1; overflow-wrap: anywhere; gap: 6px; }
.business-detail { margin-top: 5px; color: var(--muted); font-size: 10.5pt; line-height: 1.3; overflow-wrap: anywhere; }
.contact-line { display: flex; justify-content: flex-start; flex-wrap: wrap; gap: 3px 18px; }
.receipt-heading { padding: 8px 18px 9px; color: #000; background: #f7f7f7; border: 1px solid #888; border-radius: 3px 3px 0 0; }
.receipt-title { font-size: 15pt; font-weight: 800; letter-spacing: 2.5px; text-transform: uppercase; }
.meta { display: grid; grid-template-columns: 1.25fr .9fr 1fr; gap: 0; margin: 0 0 14px; background: #fff; border: 1px solid #888; border-top: 0; border-radius: 0 0 3px 3px; overflow: hidden; }
.meta > span { min-height: 46px; padding: 7px 10px; background: #fff; border: 0; border-right: 1px solid #aaa; display: flex; flex-direction: column; justify-content: center; }
.meta > span:last-child { border-right: 0; }
.meta strong { color: var(--muted); font-size: 7.5pt; letter-spacing: .6px; text-transform: uppercase; }
.meta-value { color: var(--ink); font-weight: 650; overflow-wrap: anywhere; }
.meta-subvalue { margin-top: 1px; color: var(--muted); font-size: 8pt; overflow-wrap: anywhere; }
table { width: 100%; margin: 0 0 16px; border-collapse: separate; border-spacing: 0; border: 1px solid var(--line); border-radius: 3px; overflow: hidden; }
thead { display: table-header-group; }
th { color: #000; background: #f7f7f7; font-size: 7.5pt; font-weight: 700; letter-spacing: .4px; line-height: 1.15; text-transform: uppercase; }
th, td { padding: 5px 6px; border: 0; border-right: 1px solid var(--line); border-bottom: 1px solid var(--line); line-height: 1.2; vertical-align: middle; }
th:last-child, td:last-child { border-right: 0; }
tbody tr:last-child td { border-bottom: 0; }
tbody tr:nth-child(even) { background: #fafafa; }
th:not(:nth-child(2)), td:not(:nth-child(2)) { text-align: center; }
th:nth-child(2), td:nth-child(2) { text-align: left; }
tr { break-inside: avoid; page-break-inside: avoid; }
.product { font-weight: 650; overflow-wrap: anywhere; }
.payment-section { display: flex; justify-content: flex-end; break-inside: avoid; page-break-inside: avoid; }
.payment-box { width: 310px; background: #fff; border: 1px solid var(--line); border-radius: 3px; overflow: hidden; }
.payment-row { display: flex; justify-content: space-between; gap: 20px; padding: 5px 12px; }
.payment-row:first-child { padding-top: 9px; }
.payment-row:last-child { padding-bottom: 9px; }
.payment-row.total { margin: 4px 0; padding: 8px 12px; color: #000; background: #f7f7f7; border-top: 1px solid #999; border-bottom: 1px solid #999; font-size: 13pt; font-weight: 800; }
.footer { margin-top: 22px; padding-top: 12px; border-top: 1px solid var(--line); color: var(--muted); font-size: 8pt; text-align: center; break-inside: avoid; }
.thanks { margin-bottom: 2px; color: var(--ink); font-size: 11pt; font-weight: 700; }
@media print and (max-width: 160mm) {
  :root { --header-mark-size: 96px; }
  body { font-size: 8.5pt; } .business-name-primary { font-size: 22pt; } .business-name-secondary { font-size: 13.5pt; } .receipt-title { font-size: 12pt; }
  .brand { min-height: 106px; padding: 8px 2px 14px; } th, td { padding: 4px; font-size: 7pt; }
  .payment-box { width: 245px; } .meta > span { min-height: 40px; padding: 5px 6px; }
  .meta { grid-template-columns: 1.15fr .9fr 1fr; gap: 0; } .meta strong { font-size: 6.5pt; } .meta-value { font-size: 8pt; } .meta-subvalue { font-size: 7pt; }
}
</style></head><body><main class="receipt">
<header class="header">
  <div class="brand">
    ${businessLogo ? `<img class="logo" src="${escapeHtml(businessLogo)}" alt="${escapeHtml(businessName)}" onerror="this.style.display='none'">` : ''}
    <div class="business-copy"><div class="business-name-lockup"><div class="business-name-primary">${escapeHtml(salesBusinessName.primary)}</div>
      ${salesBusinessName.secondary ? `<div class="business-name-secondary">${salesBusinessName.secondaryUnits.map(unit => `<span>${escapeHtml(unit)}</span>`).join('')}</div>` : ''}
      </div>
      <div class="contact-line">
      ${businessAddress ? `<div class="business-detail">Address: ${escapeHtml(businessAddress)}</div>` : ''}
        ${businessPhone ? `<div class="business-detail">Phone: ${escapeHtml(businessPhone)}</div>` : ''}
      </div>
    </div>
  </div>
  <div class="receipt-heading"><div class="receipt-title">${translations.salesReceipt || 'Sales Receipt'}</div></div>
</header>
<section class="meta">
  <span><strong>${translations.customer || 'Customer'}</strong><span class="meta-value">${escapeHtml(customerName)}</span>${customerPhone ? `<small class="meta-subvalue">${translations.phone || 'Phone'}: ${escapeHtml(customerPhone)}</small>` : ''}</span>
  <span><strong>${translations.bn || 'BN'}</strong><span class="meta-value">${escapeHtml(String(bn))}</span></span>
  <span><strong>${translations.dateTime || 'Date & Time'}</strong><span class="meta-value">${escapeHtml(receiptDate)}</span></span>
</section>
<table><thead><tr>
  <th style="width:5%">#</th><th style="width:43%">${translations.productName || 'Product'}</th>
  <th style="width:14%">${translations.quantity || 'Qty'}</th><th style="width:18%">${translations.price || 'Price'}</th>
  <th style="width:20%">${translations.total || 'Total'}</th>
</tr></thead><tbody>
${saleData.items.map((item, index) => `<tr><td>${index + 1}</td><td><div class="product">${escapeHtml(item.product_name || 'Product')}</div></td><td>${Math.round(Number(item.quantity) || 0)}</td><td>${money(item.price)}</td><td>${money(item.total ?? Number(item.price) * Number(item.quantity))}</td></tr>`).join('')}
</tbody></table>
<section class="payment-section"><div class="payment-box">
  ${previousBalance > 0 ? `<div class="payment-row"><span>Previous Balance</span><span>${money(previousBalance)}</span></div>` : ''}
  <div class="payment-row"><span>${translations.subtotal || 'Subtotal'}</span><span>${money(subtotal)}</span></div>
  ${Number(tax) > 0 ? `<div class="payment-row"><span>${translations.tax || 'Tax'}</span><span>${money(tax)}</span></div>` : ''}
  ${Number(discount) > 0 ? `<div class="payment-row"><span>${translations.discount || 'Discount'}</span><span>-${money(discount)}</span></div>` : ''}
  <div class="payment-row total"><span>${translations.grandTotal || 'Grand Total'}</span><span>${money(grandTotal)}</span></div>
  ${previousBalance > 0 ? `<div class="payment-row"><strong>Total Payable</strong><strong>${money(payableTotal)}</strong></div>` : ''}
  <div class="payment-row"><span>${translations.paidAmount || 'Paid'}</span><span>${money(paidAmount)}</span></div>
  ${paymentLines.filter(line => Number(line.amount || 0) > 0).map(line => `<div class="payment-row"><span>${escapeHtml(paymentTypeLabel(line.payment_type))}${line.account_name ? ` — ${escapeHtml(line.account_name)}` : ''}${line.reference_no ? ` (${escapeHtml(line.reference_no)})` : ''}</span><span>${money(line.amount)}</span></div>`).join('')}
  <div class="payment-row"><span>${translations.balance || 'Balance'}</span><span>${money(balance)}</span></div>
</div></section>
  <footer class="footer"><div class="thanks">${translations.thankYou || 'Thank you for your business!'}</div><div>Powered by OurZest PVT LTD.</div></footer>
</main><script>
window.onload = async function () {
  await Promise.all(Array.from(document.images).map(img => img.complete ? Promise.resolve() : new Promise(resolve => { img.onload = resolve; img.onerror = resolve; })));
  if (document.fonts && document.fonts.ready) await document.fonts.ready;
  window.print();
};
</script></body></html>`);
    printWindow.document.close();
    printWindow.focus();
};
// Previous purchase-style printer retained only as an unused reference.
const handlePrintBill = async (purchase) => {
    if (!purchase) return;

    showToast('info', 'Loading purchase details for print...');

    let purchaseData = purchase;

    if (!purchase.items && purchase.id && currentShop) {
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_purchases.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_record',
                    id: purchase.id,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success' && data.data) {
                purchaseData = data.data;
            } else {
                showToast('error', 'Could not load purchase details for printing');
                return;
            }
        } catch (error) {
            console.error('Error fetching purchase details for print:', error);
            showToast('error', 'Could not load purchase details for printing');
            return;
        }
    }

    if (!purchaseData.items || purchaseData.items.length === 0) {
        showToast('warning', 'No items to print receipt');
        return;
    }

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        showToast('error', 'Please allow popups for printing');
        return;
    }

    const shopName = businessInfo?.businessname || currentShop?.shop_name || 'OurZest Store';
    const shopAddress = businessInfo?.businessaddress || '';
    const businessPhone = businessInfo?.phonenumber || '';
    const businessLogo = businessInfo?.bussinesslogo_url || businessInfo?.bussinesslogo || '';
    const purchaseBusinessName = splitBusinessName(shopName);
    const supplierName = purchaseData.supplier_name || 'Walk-in Supplier';

    const formatReceiptDateTime = (dateString) => {
        const date = dateString ? new Date(dateString) : new Date();
        const validDate = isNaN(date.getTime()) ? new Date() : date;
        const datePart = validDate.toLocaleDateString('en-IN', {
            day: '2-digit', month: '2-digit', year: 'numeric'
        });
        const timePart = validDate.toLocaleTimeString('en-IN', {
            hour: '2-digit', minute: '2-digit', hour12: true
        });
        return `${datePart} ${timePart}`;
    };

    const formatReceiptCurrency = (amount) => {
        if (!amount && amount !== 0) return 'Rs. 0';
        return `Rs. ${Math.round(parseFloat(amount) || 0)}`;
    };

    const receiptDateTime = formatReceiptDateTime(purchaseData.date);
    const grandTotal = purchaseData.grand_total || '0';
    const paidAmount = purchaseData.paid || '0';
    const balance = purchaseData.balance || Math.round(parseFloat(grandTotal) - parseFloat(paidAmount));
    const tax = purchaseData.tax || 0;
    const discount = purchaseData.discount || 0;

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
        <title>Purchase Bill ${purchaseData.bill_no}</title>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
            @page {
                size: A4 portrait;
                margin: 10mm 15mm;
            }
            * { 
                margin: 0; 
                padding: 0; 
                box-sizing: border-box; 
            }
            body {
                background: #ffffff;
                font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
                color: #1f2937;
                font-size: 10pt;
                line-height: 1.5;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                min-height: 100vh;
            }
            .receipt-wrapper {
                width: 100%;
                max-width: 1000px;
                padding: 0;
                margin: 0 auto;
            }
            .receipt { 
                width: 100%; 
                padding: 5px 0;
                margin: 0 auto;
            }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .text-left { text-align: left; }
            .fw-900 { font-weight: 900; }
            .fw-700 { font-weight: 700; }
            .border-bottom { 
                border-bottom: 2px solid #e5e7eb; 
                padding-bottom: 8px; 
                margin-bottom: 8px; 
            }
            .border-top { 
                border-top: 2px solid #e5e7eb; 
                padding-top: 8px; 
                margin-top: 8px; 
            }
            .border-dash { 
                border-bottom: 1px dashed #d1d5db; 
                padding-bottom: 5px; 
                margin-bottom: 5px; 
            }
            .flex-row { 
                display: flex; 
                justify-content: space-between; 
                align-items: baseline; 
                flex-wrap: wrap;
                gap: 4px 15px;
            }
            .flex-col { display: flex; flex-direction: column; }
            .gap-1 { gap: 4px; }
            .mt-1 { margin-top: 6px; }
            .mb-1 { margin-bottom: 6px; }
            .p-1 { padding: 4px; }
            .bg-light { background: #f9fafb; }

            /* HEADER STYLES */
            .header-center {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 18px;
                min-height: 140px;
                margin-left: -18px;
                text-align: left;
                border-bottom: 3px double #e5e7eb;
                padding: 14px 4px 22px;
                margin-bottom: 12px;
            }
            .header-logo {
                display: block;
                flex: 0 0 auto;
                margin: 0;
                max-height: 112px;
                max-width: 158px;
                width: 158px;
                height: auto;
                object-fit: contain;
            }
            .header-business-copy { min-width: 0; text-align: left; }
            .business-name-lockup { display: inline-flex; flex-direction: column; width: max-content; max-width: 100%; }
            .business-name-primary {
                font-size: 28pt;
                font-weight: 900;
                text-transform: uppercase;
                letter-spacing: .5px;
                line-height: 1.02;
                color: #1f2937;
            }
            .business-name-secondary {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin-top: 4px;
                font-size: 17pt;
                font-weight: 650;
                letter-spacing: .3px;
                line-height: 1.1;
                color: #374151;
            }
            .business-phone {
                font-size: 12pt;
                font-weight: 600;
                margin-top: 5px;
                color: #4b5563;
            }
            .business-addr {
                font-size: 11pt;
                font-weight: 500;
                margin-top: 2px;
                color: #6b7280;
            }

            .receipt-title {
                text-align: center;
                font-size: 16pt;
                font-weight: 800;
                letter-spacing: 3px;
                color: #1f2937;
                border-bottom: 2px solid #e5e7eb;
                padding-bottom: 6px;
                margin-bottom: 6px;
            }
            .receipt-bill-number {
                text-align: center;
                font-size: 12pt;
                font-weight: 700;
                margin-bottom: 4px;
                color: #374151;
            }
            .receipt-bill-number strong { font-weight: 900; color: #1f2937; }
            .receipt-customer {
                text-align: center;
                font-size: 12pt;
                font-weight: 700;
                margin-bottom: 6px;
                color: #374151;
            }
            .receipt-customer strong { font-weight: 900; color: #1f2937; }

            /* META INFO */
            .bill-meta {
                display: flex;
                justify-content: space-between;
                font-size: 10.5pt;
                font-weight: 600;
                padding: 4px 0;
                border-bottom: 1px solid #e5e7eb;
                margin-bottom: 6px;
                flex-wrap: wrap;
                gap: 4px 12px;
                color: #4b5563;
            }
            .bill-meta strong { color: #1f2937; }

            .customer-box {
                background: #f9fafb;
                padding: 8px 12px;
                border-left: 4px solid #6366f1;
                border: 1px solid #e5e7eb;
                border-left-width: 4px;
                margin: 6px 0 10px 0;
                font-size: 10.5pt;
                border-radius: 4px;
            }
            .customer-box .label { font-weight: 600; color: #4b5563; }

            .datetime-center {
                text-align: center;
                font-size: 11pt;
                font-weight: 600;
                padding: 4px 0;
                margin-bottom: 6px;
                color: #4b5563;
            }
            .datetime-center strong { color: #1f2937; }

            /* ITEMS TABLE */
            .items-table {
                width: 100%;
                border-collapse: collapse;
                margin: 8px 0 12px 0;
                border: 1px solid #d1d5db;
                border-radius: 4px;
                overflow: hidden;
                font-size: 9.5pt;
            }
            .items-table thead {
                background: #f3f4f6;
            }
            .items-table th {
                text-align: center;
                padding: 8px 6px;
                font-size: 9pt;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                font-weight: 700;
                color: #374151;
                border-bottom: 2px solid #d1d5db;
                border-right: 1px solid #e5e7eb;
            }
            .items-table th:last-child {
                border-right: none;
            }
            .items-table td {
                padding: 7px 6px;
                border: 1px solid #e5e7eb;
                font-size: 10pt;
                font-weight: 500;
                vertical-align: middle;
                text-align: center;
                color: #1f2937;
            }
            .items-table th:first-child, 
            .items-table td:first-child { 
                text-align: center; 
                width: 6%;
            }
            .items-table th:nth-child(2), 
            .items-table td:nth-child(2) { 
                text-align: left; 
                width: 44%;
            }
            .items-table th:nth-child(3), 
            .items-table td:nth-child(3) { 
                text-align: center; 
                width: 12%;
            }
            .items-table th:nth-child(4), 
            .items-table td:nth-child(4) { 
                text-align: right; 
                width: 16%;
            }
            .items-table th:nth-child(5), 
            .items-table td:nth-child(5) { 
                text-align: right; 
                width: 16%;
            }
            .items-table tr:nth-child(even) {
                background: #fafafa;
            }
            .items-table tr:hover {
                background: #f3f4f6;
            }
            .product-name { 
                font-weight: 600; 
                word-break: break-word; 
                color: #1f2937;
            }
            .product-meta {
                display: block;
                font-size: 8pt;
                color: #6b7280;
                font-weight: 400;
                margin-top: 2px;
            }

            /* PAYMENT BOX */
            .payment-box {
                margin-top: 8px;
                padding-top: 8px;
                border-top: 2px solid #e5e7eb;
                max-width: 400px;
                margin-left: auto;
            }
            .payment-row {
                display: flex;
                justify-content: space-between;
                padding: 3px 0;
                font-size: 11pt;
                font-weight: 600;
                color: #374151;
            }
            .payment-row .label { color: #4b5563; font-weight: 500; }
            .payment-row .value { font-weight: 600; }
            .payment-row.total {
                font-size: 13pt;
                font-weight: 900;
                border-top: 2px solid #1f2937;
                margin-top: 4px;
                padding-top: 6px;
                color: #1f2937;
            }
            .payment-row.total .value {
                color: #059669;
            }
            .payment-row .value.text-danger { color: #dc2626; }
            .payment-row .value.text-primary { color: #3b82f6; }
            .payment-row .value.text-warning { color: #d97706; }
            .payment-row .value.text-success { color: #059669; }

            /* FOOTER */
            .footer {
                text-align: center;
                font-size: 9.5pt;
                margin-top: 12px;
                padding-top: 10px;
                border-top: 2px solid #e5e7eb;
                font-weight: 500;
                color: #6b7280;
            }
            .thankyou { 
                font-size: 12pt; 
                font-weight: 700; 
                color: #1f2937;
                margin-bottom: 4px;
            }
            .powered-by {
                font-size: 8pt;
                color: #9ca3af;
                letter-spacing: 0.5px;
            }

            /* RESPONSIVE - A5 and smaller */
            @media print and (max-width: 160mm) {
                body { font-size: 9pt; }
                .business-name-primary { font-size: 22pt; }
                .business-name-secondary { font-size: 13.5pt; }
                .receipt-title { font-size: 13pt; }
                .items-table { font-size: 8.5pt; }
                .items-table th, .items-table td { padding: 5px 4px; }
                .payment-box { max-width: 300px; }
                .payment-row { font-size: 10pt; }
                .payment-row.total { font-size: 12pt; }
                .header-center { min-height: 106px; margin-left: -12px; gap: 14px; padding: 8px 2px 14px; }
                .header-logo { max-height: 80px; max-width: 112px; width: 112px; }
            }

            @media print and (max-width: 120mm) {
                .items-table th, .items-table td { padding: 4px 3px; font-size: 7.5pt; }
                .business-name-primary { font-size: 18pt; }
                .business-name-secondary { font-size: 11pt; }
                .receipt-title { font-size: 11pt; }
                .payment-box { max-width: 250px; }
                .payment-row { font-size: 9pt; }
                .payment-row.total { font-size: 10.5pt; }
            }

            @media print {
                body { margin: 0; padding: 0; }
                .no-print { display: none; }
            }

            /* PAPER SIZE OVERRIDES via data attributes */
            @media print and (size: A5) {
                body { font-size: 8.5pt; }
                .business-name-primary { font-size: 19pt; }
                .business-name-secondary { font-size: 12pt; }
                .items-table th, .items-table td { padding: 4px 4px; font-size: 8pt; }
            }
            @media print and (size: LEGAL) {
                body { font-size: 10.5pt; }
                .items-table { font-size: 10pt; }
            }
        </style>
    </head>
    <body>
        <div class="receipt-wrapper">
            <div class="receipt">
                <!-- HEADER -->
                <div class="header-center">
                    ${businessLogo ? `<img src="${businessLogo}" alt="logo" class="header-logo" onerror="this.style.display='none'" />` : ''}
                    <div class="header-business-copy">
                        <div class="business-name-lockup">
                            <div class="business-name-primary">${escapeHtml(purchaseBusinessName.primary)}</div>
                            ${purchaseBusinessName.secondary ? `<div class="business-name-secondary">${purchaseBusinessName.secondaryUnits.map(unit => `<span>${escapeHtml(unit)}</span>`).join('')}</div>` : ''}
                        </div>
                        ${businessPhone ? `<div class="business-phone">Phone: ${escapeHtml(businessPhone)}</div>` : ''}
                        ${shopAddress ? `<div class="business-addr">Address: ${escapeHtml(shopAddress)}</div>` : ''}
                    </div>
                </div>

                <!-- TITLE -->
                <div class="receipt-title">${translations.purchaseReceipt || 'PURCHASE RECEIPT'}</div>
                <div class="receipt-bill-number"><strong>${translations.billNumber || 'Bill No'}:</strong> #${escapeHtml(purchaseData.bill_no || '')}</div>
                <div class="receipt-customer">${translations.supplier || 'Supplier'}: <strong>${escapeHtml(supplierName)}</strong></div>

                <!-- DATE/TIME -->
                <div class="datetime-center">
                    <strong>${translations.date || 'Date'}:</strong> ${receiptDateTime}
                </div>

                <!-- SUPPLIER CONTACT INFO -->
                ${(purchaseData.phone || purchaseData.address) ? `
                <div class="customer-box">
                    ${purchaseData.phone ? `<div><span class="label">📞 Phone:</span> ${escapeHtml(purchaseData.phone)}</div>` : ''}
                    ${purchaseData.address ? `<div><span class="label">📍 Address:</span> ${escapeHtml(purchaseData.address)}</div>` : ''}
                </div>` : ''}

                <!-- ITEMS TABLE -->
                <table class="items-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>${translations.productName || 'Product'}</th>
                            <th>${translations.quantity || 'Qty'}</th>
                            <th>${translations.price || 'Price'}</th>
                            <th>${translations.total || 'Total'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${purchaseData.items.map((item, idx) => `
                            <tr>
                                <td>${idx + 1}</td>
                                <td>
                                    <div class="product-name">${escapeHtml(item.product_name || 'Product')}</div>
                                    ${(item.batch_no || item.barcode) ? `
                                    <span class="product-meta">
                                        ${item.batch_no ? `Batch: ${escapeHtml(item.batch_no)}` : ''}
                                        ${item.batch_no && item.barcode ? ' | ' : ''}
                                        ${item.barcode ? `Barcode: ${escapeHtml(item.barcode)}` : ''}
                                    </span>` : ''}
                                </td>
                                <td>${Math.round(parseFloat(item.quantity) || 0)}</td>
                                <td>${formatReceiptCurrency(item.price)}</td>
                                <td>${formatReceiptCurrency(item.total || item.price * item.quantity)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <!-- PAYMENT SUMMARY -->
                <div class="payment-box">
                    <div class="payment-row">
                        <span class="label">${translations.subtotal || 'Subtotal'}</span>
                        <span class="value">${formatReceiptCurrency(grandTotal)}</span>
                    </div>
                    ${parseFloat(tax) > 0 ? `
                    <div class="payment-row">
                        <span class="label">${translations.tax || 'Tax'}</span>
                        <span class="value">${formatReceiptCurrency(tax)}</span>
                    </div>` : ''}
                    ${parseFloat(discount) > 0 ? `
                    <div class="payment-row">
                        <span class="label">${translations.discount || 'Discount'}</span>
                        <span class="value text-danger">-${formatReceiptCurrency(discount)}</span>
                    </div>` : ''}
                    <div class="payment-row total">
                        <span class="label">${translations.grandTotal || 'GRAND TOTAL'}</span>
                        <span class="value">${formatReceiptCurrency(grandTotal)}</span>
                    </div>
                    ${parseFloat(paidAmount) > 0 ? `
                    <div class="payment-row">
                        <span class="label">${translations.paidAmount || 'Paid'}</span>
                        <span class="value text-primary">${formatReceiptCurrency(paidAmount)}</span>
                    </div>` : ''}
                    ${parseFloat(balance) > 0 ? `
                    <div class="payment-row">
                        <span class="label">${translations.balance || 'Balance'}</span>
                        <span class="value text-warning">${formatReceiptCurrency(balance)}</span>
                    </div>` : ''}
                    ${parseFloat(balance) <= 0 && parseFloat(paidAmount) > 0 ? `
                    <div class="payment-row">
                        <span class="label">${translations.balance || 'Balance'}</span>
                        <span class="value text-success">${formatReceiptCurrency(balance)}</span>
                    </div>` : ''}
                </div>

                <!-- FOOTER -->
                <div class="footer">
                    <div class="thankyou">${translations.thankYou || 'Thank you for your business!'}</div>
                    <div class="powered-by">Developed by OurZest PVT LTD.</div>
                </div>
            </div>
        </div>

        <script>
            // Paper size selector for print
            const paperSize = localStorage.getItem('receipt_paper_size') || 'A4';
            const orientation = localStorage.getItem('receipt_orientation') || 'portrait';
            
            // Apply paper size via @page
            const style = document.createElement('style');
            style.textContent = \`
                @page {
                    size: \${paperSize} \${orientation};
                    margin: 10mm 15mm;
                }
            \`;
            document.head.appendChild(style);

            window.onload = function() {
                setTimeout(function() {
                    window.print();
                    window.onafterprint = function() { window.close(); };
                }, 500);
            };
        </script>
    </body>
    </html>
`);

    printWindow.document.close();
    printWindow.focus();
};
    const handleView = async (sale) => {
        setSelectedSale(sale);

        if (!sale.items && sale.id && currentShop) {
            try {
                const response = await fetch(SELL_API, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        action: 'get_record',
                        id: sale.id,
                        shop_id: currentShop.shop_id
                    })
                });
                const data = await response.json();
                if (data.status === 'success' && data.data) {
                    setSelectedSale(data.data);
                }
            } catch (error) {
                console.error('Error fetching sale details:', error);
            }
        }

        setShowViewModal(true);
    };

    const handleEdit = async (sale) => {
        let saleData = sale;
        try {
            const response = await fetch(SELL_API, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_record', id: sale.id, username: user?.username, shop_id: currentShop?.shop_id })
            });
            const result = await response.json();
            if (result.status !== 'success' || !result.data) throw new Error(result.message || 'Could not load sale');
            saleData = result.data;
        } catch (error) { showToast('error', error.message || 'Could not load sale'); return; }
        const editableItems = (saleData.items || []).map(item => ({ ...item,
            quantity: String(item.display_quantity ?? item.quantity ?? 1), price: String(item.price ?? ''),
            total: String(item.total ?? '0.00'), available_stock: Number(item.available_stock ?? 0) + Number(item.quantity ?? 0),
            sell_method: item.sell_method || (item.sell_unit === 'pack' ? 'packing' : 'sub_packing')
        }));
        setSelectedSale(saleData);
        setEditFormData({
            id: saleData.id, date: saleData.date ? saleData.date.split('T')[0] : '',
            bill_number: saleData.bill_number || '', bn: saleData.bn || '', customer_name: saleData.customer_name || '',
            customer_phone: saleData.customer_phone || '',
            subtotal: saleData.subtotal || '', tax: saleData.tax || '', discount: saleData.discount || '',
            grand_total: saleData.grand_total || '', paid_amount: saleData.paid_amount || '', balance: saleData.balance || '',
            payment_method: saleData.payment_method || 'cash', payment_status: saleData.payment_status || 'unpaid',
            notes: saleData.notes || '', courier_name: saleData.courier_name || '',
            tracking_number: saleData.tracking_number || '', packing_status: saleData.packing_status || 'unpacked',
            items: editableItems
        });
        setEditFormErrors({});
        setShowEditModal(true);
    };

    const handleDeleteClick = (saleId) => {
        const sale = sales.find(s => s.id === saleId);
        if (!sale) return;
        if (sale.username !== user?.username) {
            showToast('error', 'You can only delete sales you added');
            return;
        }
        setSaleToDelete(saleId);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!saleToDelete || !currentShop) return;
        const sale = sales.find(s => s.id === saleToDelete);
        if (!sale || sale.username !== user?.username) {
            showToast('error', 'You can only delete your own sales');
            setShowDeleteModal(false);
            setSaleToDelete(null);
            return;
        }
        try {
            const response = await fetch(SELL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete',
                    id: saleToDelete,
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', translations.deletedSuccess || 'Sale deleted successfully');
                fetchSales();
                setShowDeleteModal(false);
                setSaleToDelete(null);
            } else {
                showToast('error', data.message || translations.deleteError || 'Error deleting sale');
            }
        } catch (error) {
            console.error('Error deleting sale:', error);
            showToast('error', translations.deleteError || 'Error deleting sale');
        }
    };

    const handleUpdateSale = async (e) => {
        e.preventDefault();
        if (!selectedSale || !currentShop) return;

        const errors = {};
        if (!editFormData.date) errors.date = translations.dateRequired || 'Date is required';
        if (!editFormData.bill_number) errors.bill_number = translations.billRequired || 'Bill number is required';
        if (String(editFormData.bn || '').trim() && !/^[A-Za-z0-9]+$/.test(String(editFormData.bn).trim())) {
            errors.bn = 'BN may contain letters and numbers only';
        }
        editFormData.items?.forEach((item, index) => {
            if (!item.product_id) errors.items = `Select a valid product on row ${index + 1}`;
            if (!(Number(item.quantity) > 0)) errors.items = `Enter a valid quantity on row ${index + 1}`;
            if (!(Number(item.price) >= 0)) errors.items = `Enter a valid price on row ${index + 1}`;
        });
        if (parseFloat(editFormData.paid_amount) > parseFloat(editFormData.grand_total)) {
            errors.paid_amount = 'Paid amount cannot exceed grand total';
        }

        if (Object.keys(errors).length > 0) {
            setEditFormErrors(errors);
            return;
        }

        setEditLoading(true);
        try {
            const response = await fetch(SELL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'edit',
                    id: selectedSale.id,
                    username: user.username,
                    shop_id: currentShop.shop_id,
                    date: editFormData.date,
                    bill_number: editFormData.bill_number,
                    bn: String(editFormData.bn || '').trim(),
                    customer_name: editFormData.customer_name,
                    customer_phone: editFormData.customer_phone,
                    customer_address: editFormData.customer_address,
                    subtotal: editFormData.subtotal,
                    tax: editFormData.tax,
                    discount: editFormData.discount,
                    grand_total: editFormData.grand_total,
                    paid_amount: editFormData.paid_amount,
                    balance: editFormData.balance,
                    payment_method: editFormData.payment_method,
                    payment_status: editFormData.payment_status,
                    notes: editFormData.notes,
                    courier_name: editFormData.courier_name,
                    tracking_number: editFormData.tracking_number,
                    packing_status: editFormData.packing_status,
                    items: editFormData.items
                })
            });
            if (!response.ok) throw new Error(`Sale update failed (${response.status})`);
            const data = await response.json();
            if (data.status === 'success') {
                const hasItemConfirmation = data.data?.items_updated !== undefined && data.data?.items_updated !== null;
                const savedItemCount = Number(data.data?.items_updated);
                if (hasItemConfirmation && (!Number.isInteger(savedItemCount) || savedItemCount !== editFormData.items.length)) {
                    throw new Error(`Server did not confirm sale items (expected ${editFormData.items.length}, received ${data.data?.items_updated ?? 'none'})`);
                }
                showToast('success', translations.saleUpdated || 'Sale updated successfully');
                setShowEditModal(false);
                fetchSales();
            } else {
                showToast('error', data.message || translations.updateError || 'Error updating sale');
            }
        } catch (error) {
            console.error('Error updating sale:', error);
            showToast('error', error?.message || translations.updateError || 'Error updating sale');
        } finally {
            setEditLoading(false);
        }
    };

    const handlePageChange = useCallback((page) => { if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page); }, [pagination.totalPages]);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
                darkMode={darkMode}
            />

            <div className="ozlistui-sticky-header">
                <div className="ozlistui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozlistui-header-content">
                    <div className="ozlistui-header-left">
                        <div className="ozlistui-header-title">
                            <h1>{translations.salesList || 'Sales List'}</h1>
                            <p>{translations.formDetails || 'All sales details are below'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-header-right">
                        <button
                            className="ozlistui-header-filter-btn"
                            onClick={() => setShowFilters(!showFilters)}
                            title={showFilters ? "Hide Filters" : "Show Filters"}
                        >
                            <FontAwesomeIcon icon={showFilters ? faEyeSlash : faFilter} />
                            <span>{showFilters ? "Hide Filters" : "Filters"}</span>
                        </button>

                        {!currentShop && (
                            <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                                <FontAwesomeIcon icon={faExchangeAlt} />
                                <span>{translations.switchShop || 'Switch Shop'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="ozlistui-filters-section">
                    <div className="ozlistui-filters-row">
                        <CustomDropdown
                            label={translations.filterBy || 'Filter By'}
                            icon={faTag}
                            value={filterBy}
                            onChange={setFilterBy}
                            options={filterByOptions}
                            translations={translations}
                        />

                        {filterBy === 'billNumber' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="billNumberFilter"
                                        value={billNumberFilter}
                                        onChange={(e) => setBillNumberFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="billNumberFilter">
                                        <FontAwesomeIcon icon={faTag} />
                                        {translations.billNumberFilter || 'Bill Number'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'customerName' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="customerNameFilter"
                                        value={customerNameFilter}
                                        onChange={(e) => setCustomerNameFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="customerNameFilter">
                                        <FontAwesomeIcon icon={faUser} />
                                        {translations.customerNameFilter || 'Customer Name'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'phone' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="tel"
                                        id="phoneFilter"
                                        value={phoneFilter}
                                        onChange={(e) => setPhoneFilter(e.target.value)}
                                        placeholder=" "
                                        dir="ltr"
                                    />
                                    <label htmlFor="phoneFilter">
                                        <FontAwesomeIcon icon={faPhone} />
                                        {translations.phoneFilter || 'Phone Number'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'added_by' && (
                            <div className="ozlistui-filter-group">
                                <div className="ozlistui-floating-wrapper">
                                    <input
                                        type="text"
                                        id="addedByFilter"
                                        value={addedByFilter}
                                        onChange={(e) => setAddedByFilter(e.target.value)}
                                        placeholder=" "
                                    />
                                    <label htmlFor="addedByFilter">
                                        <FontAwesomeIcon icon={faUser} />
                                        {translations.addedByFilter || 'Added By'}
                                    </label>
                                </div>
                            </div>
                        )}

                        {filterBy === 'date' && (
                            <>
                                <div className="ozlistui-filter-group ozlistui-date-filter">
                                    <div className="ozlistui-floating-wrapper">
                                        <input
                                            type="date"
                                            id="startDate"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            max={getTodayDate()}
                                            placeholder=" "
                                        />
                                        <label htmlFor="startDate">
                                            <FontAwesomeIcon icon={faCalendar} />
                                            {translations.startDate || 'Start Date'}
                                        </label>
                                    </div>
                                </div>
                                <div className="ozlistui-filter-group ozlistui-date-filter">
                                    <div className="ozlistui-floating-wrapper">
                                        <input
                                            type="date"
                                            id="endDate"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            min={startDate}
                                            max={getTodayDate()}
                                            placeholder=" "
                                        />
                                        <label htmlFor="endDate">
                                            <FontAwesomeIcon icon={faCalendar} />
                                            {translations.endDate || 'End Date'}
                                        </label>
                                    </div>
                                </div>
                            </>
                        )}

                        {filterBy === 'paymentStatus' && (
                            <CustomDropdown
                                label={translations.paymentStatusFilter || 'Payment Status'}
                                icon={faCreditCard}
                                value={paymentStatusFilter}
                                onChange={setPaymentStatusFilter}
                                options={paymentStatusOptions}
                                translations={translations}
                            />
                        )}

                        <CustomDropdown
                            label={translations.orientation || 'Orientation'}
                            icon={faFilePdf}
                            value={pdfOrientation}
                            onChange={setPdfOrientation}
                            options={pdfOrientationOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label={translations.pageSize || 'Page Size'}
                            icon={faFilePdf}
                            value={pdfPageSize}
                            onChange={setPdfPageSize}
                            options={pdfPageSizeOptions}
                            translations={translations}
                        />

                        <CustomDropdown
                            label="Page Range"
                            icon={faFilePdf}
                            value={pdfPageRange}
                            onChange={setPdfPageRange}
                            options={pdfPageRangeOptions}
                            translations={translations}
                        />

                        {pdfPageRange === 'range' && (
                            <>
                                <div className="ozlistui-filter-group" style={{ width: '70px' }}>
                                    <div className="ozlistui-floating-wrapper">
                                        <input
                                            type="number"
                                            min="1"
                                            value={pdfStartPage}
                                            onChange={(e) => setPdfStartPage(Math.max(1, parseInt(e.target.value) || 1))}
                                            placeholder=" "
                                        />
                                        <label>From</label>
                                    </div>
                                </div>
                                <div className="ozlistui-filter-group" style={{ width: '70px' }}>
                                    <div className="ozlistui-floating-wrapper">
                                        <input
                                            type="number"
                                            min={pdfStartPage}
                                            value={pdfEndPage}
                                            onChange={(e) => setPdfEndPage(Math.max(pdfStartPage, parseInt(e.target.value) || pdfStartPage))}
                                            placeholder=" "
                                        />
                                        <label>To</label>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="ozlistui-filter-group">
                            <button onClick={fetchSales} className="ozlistui-refresh-btn" disabled={loading}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                            </button>
                        </div>

                        <div className="ozlistui-filter-group">
                            <button
                                onClick={exportToPDF}
                                className="ozlistui-refresh-btn"
                                disabled={filteredSales.length === 0 || pdfLoading}
                                style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                            >
                                {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                                <span className="ozlistui-btn-text">{translations.exportToPDF || 'Export PDF'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingUserData || 'Loading your sales data...'}</p>
                </div>
            ) : !currentShop ? (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view sales'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="ozlistui-table-scroll">
                        <div className="ozlistui-table-container">
                            <div className="ozlistui-table-wrapper">
                                <table className="ozlistui-table">
                                    <thead>
                                        <tr>
                                            <th className="ozlistui-id-column ozlistui-centered-cell">{translations.serialNo || 'S.No'}</th>
                                            <th className="ozlistui-centered-cell">{translations.date || 'Date'}</th>
                                    
                                            <th className="ozlistui-centered-cell">{translations.bn || 'BN'}</th>
                                            <th className="ozlistui-centered-cell">{translations.customerName || 'Customer'}</th>
                                            <th className="ozlistui-centered-cell">{translations.grandTotal || 'Total'}</th>
                                            <th className="ozlistui-centered-cell">{translations.paidAmount || 'Paid'}</th>
                                            <th className="ozlistui-centered-cell">{translations.balance || 'Balance'}</th>
                                            <th className="ozlistui-centered-cell">{translations.paymentStatus || 'Status'}</th>
                                            <th className="ozlistui-centered-cell">{translations.paymentMethod || 'Payment'}</th>
                                            <th className="ozlistui-centered-cell">{translations.addedBy || 'Added By'}</th>
                                            <th className="ozlistui-actions-column ozlistui-centered-cell">{translations.actions || 'Actions'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagination.currentSales.map((sale, index) => {
                                            const paymentStatus = getPaymentStatus(sale.paid_amount, sale.grand_total);
                                            const addedBy = sale.username || '-';
                                            const isSelfAdded = addedBy === user?.username;

                                            return (
                                                <tr key={sale.id}>
                                                    <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{formatDate(sale.date)}</span>
                                                    </td>
                                                
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{sale.bn || '-'}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{sale.customer_name || (translations.walkInCustomer || 'Walk-in')}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: '#059669', fontWeight: 'bold' }}>{formatCurrency(sale.grand_total)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: '#3b82f6', fontWeight: 'bold' }}>{formatCurrency(sale.paid_amount)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text" style={{ color: parseFloat(sale.balance) > 0 ? '#d97706' : '#059669', fontWeight: 'bold' }}>{formatCurrency(sale.balance)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <div className="ozlistui-payment-badge" style={{ backgroundColor: `${paymentStatus.color}20`, color: paymentStatus.color, border: `1px solid ${paymentStatus.color}40`, display: 'inline-block', padding: '0.2rem 0.6rem', fontSize: '0.7rem' }}>
                                                            {paymentStatus.text}
                                                        </div>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className="ozlistui-cell-text">{getPaymentMethodLabel(sale.payment_method)}</span>
                                                    </td>
                                                    <td className="ozlistui-centered-cell">
                                                        <span className={`ozlistui-added-by-badge ${isSelfAdded ? 'ozlistui-self' : ''}`}>
                                                            {addedBy}
                                                        </span>
                                                    </td>
                                                    <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                        <div className="ozlistui-actions-content">
                                                            <button onClick={() => handlePrint(sale)} className="ozlistui-action-btn ozlistui-print-btn" title={translations.print || 'Print'}>
                                                                <FontAwesomeIcon icon={faPrint} />
                                                            </button>
                                                            <button onClick={() => handleView(sale)} className="ozlistui-action-btn ozlistui-view-btn" title={translations.view || 'View'}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </button>
                                                            <button onClick={() => handleEdit(sale)} className="ozlistui-action-btn ozlistui-edit-btn" title={translations.edit || 'Edit'} disabled={!isSelfAdded} style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                            <button onClick={() => handleDeleteClick(sale.id)} className="ozlistui-action-btn ozlistui-delete-btn" title={translations.delete || 'Delete'} disabled={!isSelfAdded} style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}>
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

{filteredSales.length > 0 && currentShop && (
    <div className="ozlistui-pagination">
        <div className="ozlistui-pagination-left">
            <div className="ozlistui-per-page">
                <span>{translations.show || 'Show'}</span>
                <select 
                    value={itemsPerPage} 
                    onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                    className="ozlistui-per-page-select"
                >
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={1000}>1000</option>
                </select>
                <span>{translations.perPage || 'per page'}</span>
            </div>
            <div className="ozlistui-pagination-info">
                <span>
                    {translations.showing || 'Showing'} 
                    <strong> {pagination.startIndex + 1} </strong>
                    {translations.to || 'to'} 
                    <strong> {Math.min(pagination.startIndex + itemsPerPage, filteredSales.length)} </strong>
                    {translations.of || 'of'} 
                    <strong> {filteredSales.length} </strong>
                    {translations.sales || 'sales'}
                </span>
            </div>
        </div>
        <div className="ozlistui-pagination-right">
            <button 
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1} 
                className="ozlistui-pagination-btn"
            >
                <FontAwesomeIcon icon={faChevronLeft} />
                <span>{translations.previous || 'Previous'}</span>
            </button>
            <div className="ozlistui-page-numbers">
                {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                    let pageNum;
                    if (pagination.totalPages <= 5) {
                        pageNum = i + 1;
                    } else if (currentPage <= 3) {
                        pageNum = i + 1;
                    } else if (currentPage >= pagination.totalPages - 2) {
                        pageNum = pagination.totalPages - 4 + i;
                    } else {
                        pageNum = currentPage - 2 + i;
                    }
                    return (
                        <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                            {pageNum}
                        </button>
                    );
                })}
            </div>
            <button 
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === pagination.totalPages} 
                className="ozlistui-pagination-btn"
            >
                <span>{translations.next || 'Next'}</span>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </div>
    </div>
)}
                </>
            )}

            {/* View Modal */}
            {showViewModal && selectedSale && (
                <div className={`ozlistui-modal-overlay ${darkMode ? 'ozlistui-dark' : ''}`} onClick={() => setShowViewModal(false)}>
                    <div className="ozlistui-modal-content ozlistui-view-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faReceipt} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.saleDetails || 'Sale Details'}</h3>
                                <span className="ozlistui-sale-number-badge">#{selectedSale.bill_number}</span>
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowViewModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="ozlistui-modal-body ozlistui-view-modal-body">
                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faInfoCircle} />Sale Information</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.saleId || 'Sale ID'}:</span><span className="ozlistui-view-value">#{selectedSale.id}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.date || 'Date'}:</span><span className="ozlistui-view-value">{formatDate(selectedSale.date)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.billNumber || 'Bill Number'}:</span><span className="ozlistui-view-value" style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{selectedSale.bill_number}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.bn || 'BN'}:</span><span className="ozlistui-view-value" style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{selectedSale.bn || '-'}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.customerName || 'Customer Name'}:</span><span className="ozlistui-view-value">{selectedSale.customer_name || (translations.walkInCustomer || 'Walk-in Customer')}</span></div>
                                    {selectedSale.customer_phone && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.phone || 'Phone'}:</span><span className="ozlistui-view-value">{selectedSale.customer_phone}</span></div>
                                    )}
                                    {selectedSale.customer_address && (
                                        <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.customerAddress || 'Address'}:</span><span className="ozlistui-view-value">{selectedSale.customer_address}</span></div>
                                    )}
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.paymentMethod || 'Payment Method'}:</span><span className="ozlistui-view-value">{getPaymentMethodLabel(selectedSale.payment_method)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.addedBy || 'Added By'}:</span><span className="ozlistui-view-value"><span className="ozlistui-added-by-badge">{selectedSale.username || '-'}</span></span></div>
                                    {selectedSale.notes && (
                                        <div className="ozlistui-view-row ozlistui-full-width"><span className="ozlistui-view-label">{translations.notes || 'Notes'}:</span><span className="ozlistui-view-value">{selectedSale.notes}</span></div>
                                    )}
                                </div>
                            </div>

                            <div className="ozlistui-view-section">
                                <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faCalculator} />Payment Summary</h4>
                                <div className="ozlistui-view-grid">
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.subtotal || 'Subtotal'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedSale.subtotal)}</span></div>
                                    {parseFloat(selectedSale.tax) > 0 && <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.tax || 'Tax'}:</span><span className="ozlistui-view-value">{formatCurrency(selectedSale.tax)}</span></div>}
                                    {parseFloat(selectedSale.discount) > 0 && <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.discount || 'Discount'}:</span><span className="ozlistui-view-value">-{formatCurrency(selectedSale.discount)}</span></div>}
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.grandTotal || 'Grand Total'}:</span><span className="ozlistui-view-value" style={{ color: '#059669', fontWeight: 'bold' }}>{formatCurrency(selectedSale.grand_total)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.paidAmount || 'Paid Amount'}:</span><span className="ozlistui-view-value" style={{ color: '#3b82f6', fontWeight: 'bold' }}>{formatCurrency(selectedSale.paid_amount)}</span></div>
                                    <div className="ozlistui-view-row"><span className="ozlistui-view-label">{translations.balance || 'Balance'}:</span><span className="ozlistui-view-value" style={{ color: parseFloat(selectedSale.balance) > 0 ? '#d97706' : '#059669', fontWeight: 'bold' }}>{formatCurrency(selectedSale.balance)}</span></div>
                                </div>
                            </div>

                            {selectedSale.items && selectedSale.items.length > 0 && (
                                <div className="ozlistui-view-section">
                                    <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faBoxes} />{translations.items || 'Items'}</h4>
                                    <div className="ozlistui-items-table-container">
                                        <table className="ozlistui-items-table">
                                            <thead>
                                                <tr>
                                                    <th>{translations.serialNo || '#'}</th>
                                                    <th>{translations.productName || 'Product'}</th>
                                                    <th>{translations.itemBatch || 'Batch'}</th>
                                                    <th>{translations.itemUnit || 'Unit'}</th>
                                                    <th className="ozlistui-text-right">{translations.price || 'Price'}</th>
                                                    <th className="ozlistui-text-right">{translations.quantity || 'Qty'}</th>
                                                    <th className="ozlistui-text-right">{translations.total || 'Total'}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedSale.items.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>{item.product_name}</td>
                                                        <td>{item.batch_no || '-'}</td>
                                                        <td>{item.unit || '-'}</td>
                                                        <td className="ozlistui-text-right">{formatCurrency(item.price)}</td>
                                                        <td className="ozlistui-text-right">{Math.round(parseFloat(item.quantity) || 0)}</td>
                                                        <td className="ozlistui-text-right ozlistui-total-cell">{formatCurrency(item.total)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowViewModal(false)}>{translations.close || 'Close'}</button>
                            <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => { setShowViewModal(false); handlePrint(selectedSale); }}>
                                <FontAwesomeIcon icon={faPrint} />
                                {translations.print || 'Print'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
            {showEditModal && selectedSale && (
                <div className={`ozlistui-modal-overlay ${darkMode ? 'ozlistui-dark' : ''}`} onClick={(e) => e.stopPropagation()}>
                    <div
                        ref={modalRef}
                        className="ozlistui-modal-content ozlistui-edit-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'fixed',
                            left: modalPosition.x || '50%',
                            top: modalPosition.y || '50%',
                            transform: modalPosition.x === 0 && modalPosition.y === 0 ? 'translate(-50%, -50%)' : 'none',
                            width: modalSize.width,
                            minWidth: '350px',
                            maxWidth: '95vw',
                            maxHeight: '85vh'
                        }}
                    >
                        <div className="ozlistui-resize-handle-top" onMouseDown={(e) => startResize(e, 'n')}></div>
                        <div className="ozlistui-resize-handle-bottom" onMouseDown={(e) => startResize(e, 's')}></div>
                        <div className="ozlistui-resize-handle-left" onMouseDown={(e) => startResize(e, 'w')}></div>
                        <div className="ozlistui-resize-handle-right" onMouseDown={(e) => startResize(e, 'e')}></div>
                        <div className="ozlistui-resize-handle-nw" onMouseDown={(e) => startResize(e, 'nw')}></div>
                        <div className="ozlistui-resize-handle-ne" onMouseDown={(e) => startResize(e, 'ne')}></div>
                        <div className="ozlistui-resize-handle-sw" onMouseDown={(e) => startResize(e, 'sw')}></div>
                        <div className="ozlistui-resize-handle-se" onMouseDown={(e) => startResize(e, 'se')}></div>

                        <div className="ozlistui-modal-header" onMouseDown={startDrag}>
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faEdit} /></div>
                            <div className="ozlistui-modal-title">
                                <h3>{translations.editSale || 'Edit Sale'}</h3>
                                <span className="ozlistui-sale-number-badge">#{selectedSale.bill_number}</span>
                            </div>
                            <div className="ozlistui-width-control-group">
                                {Object.entries(widthModes).map(([key, mode]) => (
                                    <button key={key} className={`ozlistui-width-btn ${currentWidthMode === key ? 'ozlistui-active' : ''}`} onClick={() => setWidthMode(key)} title={mode.label}>
                                        <FontAwesomeIcon icon={mode.icon} />
                                    </button>
                                ))}
                            </div>
                            <button className="ozlistui-close-btn" onClick={() => setShowEditModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={handleUpdateSale}>
                            <div className="ozlistui-modal-body">
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.date ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_date"
                                                name="date"
                                                value={editFormData.date}
                                                onChange={(e) => setEditFormData({ ...editFormData, date: e.target.value })}
                                                max={getTodayDate()}
                                                placeholder=" "
                                                className={editFormErrors.date ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_date">
                                                <FontAwesomeIcon icon={faCalendar} />
                                                {translations.date || 'Date'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.date && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.date}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.bill_number ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_bill_number"
                                                name="bill_number"
                                                value={editFormData.bill_number}
                                                onChange={(e) => setEditFormData({ ...editFormData, bill_number: e.target.value })}
                                                placeholder=" "
                                                disabled={editLoading}
                                            />
                                            <label htmlFor="edit_bill_number">
                                                <FontAwesomeIcon icon={faFileInvoice} />
                                                {translations.billNumber || 'Bill Number'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.bill_number && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.bill_number}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.bn ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_bn"
                                                name="bn"
                                                value={editFormData.bn}
                                                onChange={(e) => setEditFormData({ ...editFormData, bn: e.target.value })}
                                                placeholder=" "
                                                maxLength={100}
                                                pattern="[A-Za-z0-9]*"
                                                title="Letters and numbers only"
                                                className={editFormErrors.bn ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_bn">
                                                <FontAwesomeIcon icon={faFileInvoice} />
                                                {translations.bn || 'BN'}
                                            </label>
                                        </div>
                                        {editFormErrors.bn && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.bn}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_customer_name"
                                                name="customer_name"
                                                value={editFormData.customer_name}
                                                onChange={(e) => setEditFormData({ ...editFormData, customer_name: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_customer_name">
                                                <FontAwesomeIcon icon={faUser} />
                                                {translations.customerName || 'Customer Name'}
                                                <span> ({translations.optional || 'Optional'})</span>
                                            </label>
                                        </div>
                                    </div>

                                
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <select
                                                id="edit_payment_method"
                                                name="payment_method"
                                                value={editFormData.payment_method}
                                                onChange={(e) => setEditFormData({ ...editFormData, payment_method: e.target.value })}
                                            >
                                                <option value="cash">{translations.cash || 'Cash'}</option>
                                                <option value="card">{translations.card || 'Card'}</option>
                                                <option value="upi">{translations.upi || 'UPI'}</option>
                                                <option value="bank_transfer">{translations.bankTransfer || 'Bank Transfer'}</option>
                                            </select>
                                            <label htmlFor="edit_payment_method">
                                                <FontAwesomeIcon icon={faCreditCard} />
                                                {translations.paymentMethod || 'Payment Method'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-edit-sale-items" role="region" aria-label="Editable sale items" tabIndex="0">
                                            <SaleItemsTable items={editFormData.items || []} onItemChange={updateEditSaleItem}
                                                onSelectProductForRow={selectEditSaleProduct} onRemove={removeEditSaleItem}
                                                onAdd={addEditSaleItem} errors={editFormErrors} disabled={editLoading}
                                                translations={translations} isRTL={isRTL} searchProductsAPI={searchEditSaleProducts}
                                                showToast={showToast} currentShop={currentShop} />
                                        </div>
                                        {editFormErrors.items && <div className="ozlistui-error-message"><FontAwesomeIcon icon={faExclamationTriangle} /> {editFormErrors.items}</div>}
                                      
                                    </div>


                                  

                                    <div className={`ozlistui-form-group ${editFormErrors.grand_total ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_grand_total"
                                                name="grand_total"
                                                value={editFormData.grand_total}
                                                readOnly
                                                step="1"
                                                min="0"
                                                placeholder="0"
                                            />
                                            <label htmlFor="edit_grand_total">
                                                <FontAwesomeIcon icon={faDollarSign} />
                                                {translations.grandTotal || 'Grand Total'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.grand_total && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.grand_total}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.paid_amount ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_paid_amount"
                                                name="paid_amount"
                                                value={editFormData.paid_amount}
                                                onChange={(e) => {
                                                    const paid = e.target.value;
                                                    setEditFormData(prev => {
                                                        return { ...prev, paid_amount: paid, ...recalculateEditSale(prev.items, prev.tax, prev.discount, paid) };
                                                    });
                                                }}
                                                step="1"
                                                min="0"
                                                placeholder="0"
                                            />
                                            <label htmlFor="edit_paid_amount">
                                                <FontAwesomeIcon icon={faMoneyBill} />
                                                {translations.paidAmount || 'Paid Amount'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.paid_amount && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.paid_amount}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-balance-display">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_balance"
                                                value={formatCurrency(editFormData.balance)}
                                                readOnly
                                                className="ozlistui-readonly-input"
                                                style={{ color: parseFloat(editFormData.balance) > 0 ? '#d97706' : '#059669', fontWeight: 'bold' }}
                                            />
                                            <label htmlFor="edit_balance">
                                                <FontAwesomeIcon icon={faBalanceScale} />
                                                {translations.balance || 'Balance'}
                                            </label>
                                        </div>
                                    </div>

                                   
                                </div>
                            </div>
                            <div className="ozlistui-modal-footer">
                                <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowEditModal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                    {translations.cancel || 'Cancel'}
                                </button>
                                <button type="submit" className="ozlistui-btn ozlistui-btn-primary" disabled={editLoading}>
                                    {editLoading ? (
                                        <>
                                            <div className="ozlistui-btn-spinner"></div>
                                            <span>{translations.updating || 'Updating...'}</span>
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faSave} />
                                            <span>{translations.saveChanges || 'Save Changes'}</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className={`ozlistui-modal-overlay ${darkMode ? 'ozlistui-dark' : ''}`} onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-content ozlistui-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="ozlistui-modal-header ozlistui-delete-header">
                            <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="ozlistui-modal-title"><h3>{translations.confirmDelete || 'Confirm Delete'}</h3></div>
                            <button className="ozlistui-close-btn" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="ozlistui-modal-body">
                            <div className="ozlistui-delete-message">
                                <p>{translations.deleteMessage || 'Are you sure you want to delete this sale?'}</p>
                                <p><FontAwesomeIcon icon={faExclamationTriangle} /> {translations.deleteWarning || 'This action cannot be undone.'}</p>
                            </div>
                        </div>
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} />{translations.noCancel || 'No, Cancel'}</button>
                            <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} />{translations.yesDelete || 'Yes, Delete'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ElectronicsSalesList;
